/**
 * Turkish UI strings — the SOURCE language. Every key added here must also be
 * added to en.ts (the type system enforces this).
 * Placeholders use {name} syntax and are filled by t(key, vars).
 */
export const tr = {
  "app.productLabel": "Forklift Takip Sistemi",
  "app.logoAlt": "Expartise Makine",
  "app.demoBadge": "Demo · örnek veri",
  "app.skipToContent": "İçeriğe geç",

  "common.loading": "Yükleniyor…",
  "common.loadError": "Veriler yüklenemedi.",
  "common.retry": "Tekrar dene",
  "common.empty": "—",
  "common.yes": "Evet",
  "common.no": "Hayır",
  "common.backToOverview": "Genel bakışa dön",

  "nav.ariaLabel": "Ana menü",
  "nav.openMenu": "Menüyü aç",
  "nav.closeMenu": "Menüyü kapat",
  "nav.overview": "Genel bakış",
  "nav.group.monitoring": "İzleme",
  "nav.liveMap": "Canlı harita",
  "nav.alarms": "Alarmlar",
  "nav.group.fleet": "Filo",
  "nav.sites": "Sahalar",
  "nav.vehicles": "Araçlar",
  "nav.devices": "Cihazlar",
  "nav.group.operators": "Operatörler",
  "nav.operators": "Operatörler",
  "nav.cards": "Kartlar",
  "nav.permissions": "Yetkiler",
  "nav.group.reports": "Raporlar",
  "nav.reportUsage": "Kullanım",
  "nav.reportEvents": "Darbe ve olaylar",
  "nav.reportRoutes": "Rota geçmişi",
  "nav.group.admin": "Yönetim",
  "nav.users": "Kullanıcılar ve roller",
  "nav.audit": "Denetim kaydı",
  "nav.settings": "Ayarlar",

  "tenant.label": "Kiracı",
  "tenant.switch": "Kiracı değiştir",
  "tenant.listLabel": "Erişebildiğiniz kiracılar",
  "tenant.platformAdmin": "Platform yöneticisi",
  "tenant.none": "Bu hesaba bağlı bir kiracı yok.",

  "role.viewer": "İzleyici",
  "role.safety": "İSG sorumlusu",
  "role.fleet_manager": "Filo yöneticisi",
  "role.admin": "Yönetici",

  "user.signOut": "Çıkış yap",
  "user.menuLabel": "Oturum açan kullanıcı",

  "topbar.searchLabel": "Araç ara",
  "topbar.searchPlaceholder": "Filo no, model veya seri no ara…",
  "topbar.language": "Dil",
  "topbar.alarms": "Alarmlar",
  "topbar.alarmsCount": "{count} açık alarm",
  "topbar.noAlarms": "Açık alarm yok",
  "topbar.account": "Hesap: {name}",
  "topbar.breadcrumb": "Bulunduğunuz yer",

  "lang.tr": "TR",
  "lang.en": "EN",
  "lang.trName": "Türkçe",
  "lang.enName": "İngilizce",

  "login.eyebrow": "Operatör konsolu",
  "login.title": "Hoş geldiniz",
  "login.subtitle": "Filonuzu izlemek için hesabınızla giriş yapın.",
  "login.email": "E-posta",
  "login.password": "Şifre",
  "login.password.show": "Şifreyi göster",
  "login.password.hide": "Şifreyi gizle",
  "login.submit": "Giriş yap",
  "login.submitting": "Giriş yapılıyor…",
  "login.method.legend": "Giriş yöntemi",
  "login.method.password": "Şifre",
  "login.method.passwordDesc": "E-posta adresiniz ve şifrenizle",
  "login.method.code": "E-posta kodu",
  "login.method.codeDesc": "Şifresiz, tek kullanımlık kodla",
  "login.remember": "Beni hatırla",
  "login.forgot": "Şifremi unuttum?",
  "login.forgot.hint": "Kodla giriş yapın, sonra Profilim → Şifre bölümünden yeni şifre belirleyin.",
  "login.code.send": "Kod gönder",
  "login.code.sending": "Gönderiliyor…",
  "login.code.sent": "{email} adresine kayıtlı bir hesap varsa giriş kodunu gönderdik. E-postadaki bağlantıyla da giriş yapabilirsiniz.",
  "login.code.sentCodeOnly": "{email} adresine kayıtlı bir hesap varsa giriş kodunu gönderdik. Oturumunuzun bu tarayıcıyla sınırlı kalması için e-postadaki kodu buraya girin.",
  "login.code.changeEmail": "Farklı bir e-posta kullan",
  "login.code.label": "Giriş kodu",
  "login.code.help": "E-postadaki {n} haneli kodu girin.",
  "login.code.resend": "Kodu tekrar gönder",
  "login.code.resendIn": "Tekrar gönder ({s} sn)",
  "login.captcha.waiting": "Güvenlik doğrulaması tamamlanınca devam edebilirsiniz.",
  "login.captcha.loadFailed": "Güvenlik doğrulaması yüklenemedi. Sayfayı yenileyin; içerik engelleyici kullanıyorsanız bu siteye izin verin.",
  "login.help": "Hesabınızı firmanızın sistem yöneticisi oluşturur. Erişim için onunla iletişime geçin.",
  "login.footerCompany": "Expartise Makine",
  "login.hero.eyebrow": "Forklift Takip Sistemi",
  "login.hero.line1": "Tüm filonuz",
  "login.hero.line2": "tek ekranda.",
  "login.hero.caption": "Darbe, konum, kontrol listesi ve akü verisi tek konsolda.",
  "login.demo.summary": "Demo ve örnek hesaplar",
  "login.demo": "Demo ile devam et",
  "login.demoNote": "Demo modu yalnızca uydurma örnek verilerle çalışır; gerçek araç veya kişi verisi içermez.",
  "login.demoAccounts": "Rolleri denemek için örnek hesaplar (şifre: {password})",
  "login.demoCode": "Demo modunda e-posta gönderilmez. E-posta kodu yönteminde örnek hesaplar için kod: {code}",
  "login.error.required": "E-posta ve şifre girin.",
  "login.error.invalid": "E-posta veya şifre hatalı.",
  "login.error.emailRequired": "Geçerli bir e-posta adresi girin.",
  "login.error.codeRequired": "E-postadaki {n} haneli kodu girin.",
  "login.error.code": "Kod hatalı veya süresi dolmuş. Yeni kod isteyip tekrar deneyin.",
  "login.error.captcha": "Güvenlik doğrulaması başarısız oldu. Doğrulamayı yeniden tamamlayıp tekrar deneyin.",
  "login.error.rateLimited": "Çok fazla deneme yapıldı. Bir dakika bekleyip tekrar deneyin.",
  "login.error.notConfigured": "Sunucu bağlantısı henüz yapılandırılmadı.",
  "login.error.generic": "Giriş yapılamadı. Lütfen tekrar deneyin.",
  "login.footer": "Expartise Makine Ltd. Şti.",

  "dashboard.title": "Genel bakış",
  "dashboard.subtitle": "{tenant} filo özeti",
  "dashboard.sitesTitle": "Sahalar",
  "dashboard.telemetryNote": "Çalışma saati, darbe ve alarm sayıları telematik üniteler veri göndermeye başladığında burada görünecek.",
  "kpi.sites": "Saha ve birim",
  "kpi.sitesSub": "{count} ana saha",
  "kpi.vehicles": "Araç",
  "kpi.vehiclesSub": "{active} aktif · {inactive} pasif",
  "kpi.devices": "Cihaz bağlı araç",
  "kpi.devicesSub": "{count} araç cihaz bekliyor",
  "kpi.users": "Kullanıcı",
  "kpi.usersSub": "{count} yönetici",
  // Sprint 7b (ADR 0018): reports and the manager KPI panel.
  "dashboard.tabs": "Genel bakış görünümleri",
  "dashboard.summaryTab": "Filo özeti",
  "nav.reportChecklist": "Kontrol listesi uyumu",
  "nav.reportHeatmap": "Isı haritası",
  "error.report_too_large": "Rapor çok büyük: en fazla 18.400 araç-gün (ör. 92 gün × 200 araç). Tarih aralığını veya araç seçimini daraltın.",
  "error.export_too_large": "Dışa aktarım en fazla 50.000 satır içerebilir. Tarih aralığını veya filtreleri daraltın.",
  "error.invalid_report_range": "Tarih aralığı geçersiz. Geçerli tarihler seçin; en fazla 92 gün (rota raporunda en fazla 24 saat) seçilebilir.",
  "kpiPanel.title": "Yönetici paneli",
  "kpiPanel.period": "Dönem",
  "kpiPanel.period.today": "Bugün",
  "kpiPanel.period.7d": "7 gün",
  "kpiPanel.period.30d": "30 gün",
  "kpiPanel.noData": "Henüz veri yok",
  "kpiPanel.noCompare": "Karşılaştırma yok",
  "kpiPanel.vsPrevious": "önceki döneme göre",
  "kpiPanel.series": "Son {days} günün günlük değerleri",
  "kpiPanel.seriesSoc": "Son {days} günün ortalama şarj yüzdesi",
  "kpiPanel.utilisation": "Filo kullanım oranı",
  "kpiPanel.utilisationSub": "{active}/{total} cihazlı araç kullanıldı · esas: {basis}",
  "kpiPanel.basis.shifts": "vardiya saatleri",
  "kpiPanel.basis.24h": "günün 24 saati",
  "kpiPanel.basis.work": "mesai saatleri",
  "kpiPanel.basis.mixed": "vardiya ve mesai saatleri (karışık)",
  "kpiPanel.basisTip": "Kullanım oranı esası: {basis}. Vardiya tanımlı sahalarda vardiya saatleri, diğerlerinde sahanın mesai saatleri (varsayılan Pzt–Cum 08–18) kullanılır.",
  "kpiPanel.impacts": "Darbe",
  "kpiPanel.impactsPer100h": "100 çalışma saatinde {value} darbe",
  "kpiPanel.impactsNoHours": "Bu dönemde çalışma saati yok",
  "kpiPanel.checklist": "Kontrol listesi uyumu",
  "kpiPanel.checklistSub": "Kullanılan {used} vardiyanın {missed} tanesinde doldurulmadı",
  "kpiPanel.noShifts": "Vardiya tanımı yok",
  "kpiPanel.noShiftsSub": "Uyum, saha vardiyaları tanımlanınca hesaplanır.",
  "kpiPanel.faults": "Açık kritik arıza",
  "kpiPanel.faultsSub": "{count} araç \"Bakım gerekli\"",
  "kpiPanel.geofence": "Saha sınırı ihlalleri",
  "kpiPanel.geofenceSub": "Yasak bölgeye giriş {enter} · Alandan çıkış {exit} · Süre aşımı {dwell}",
  "kpiPanel.battery": "Akü",
  "kpiPanel.batteryValue": "{count} araç düşük şarjda",
  "kpiPanel.batterySub": "Derin deşarj {deep} · ortalama şarj %{avg}",
  "kpiPanel.lift": "Aşırı yük",
  "kpiPanel.liftSub": "Asansör modülünün bildirdiği aşırı yük olayları",
  "kpiPanel.documents": "Süresi yaklaşan operatör belgeleri",
  "kpiPanel.documentsSub": "30 gün içinde bitiyor · {expired} operatörün zorunlu belgesi bitmiş",
  "kpiPanel.footnote": "Saatler {tz} saat dilimine göre. Kullanım verisi dakikada bir güncellenir. Bir kutucuğa tıklayınca ilgili rapor aynı filtrelerle açılır.",
  "kpiPanel.withoutDevice": "{count} araçta henüz cihaz yok; kullanım oranına girmez.",
  "reports.sample": "Örnek veri",
  "reports.tz": "Günler ve saatler {tz} saat dilimine göre.",
  "reports.rows": "{count} satır",
  "reports.totals": "Toplamlar",
  "reports.noData": "Henüz veri yok. Bu filtrelere uyan kayıt bulunamadı.",
  "reports.truncated": "Liste ilk {max} satırla sınırlandı. Tarih aralığını veya filtreleri daraltın.",
  "reports.km": "{km} km",
  "reports.kg": "{kg} kg",
  "reports.hours": "{h} sa",
  "reports.estimated": "(tahmini)",
  "reports.severity": "seviye {level}",
  "reports.operatorsHidden": "+{count} operatör (görme yetkiniz yok)",
  "reports.unknownCards": "Bilinmeyen kart: {count}",
  "reports.duration.hm": "{h} sa {m} dk",
  "reports.duration.m": "{m} dk",
  "reports.status.open": "Açık",
  "reports.status.acknowledged": "Onaylandı",
  "reports.basis.shifts": "Vardiya",
  "reports.basis.24h": "Günün 24 saati",
  "reports.basis.work": "Mesai saati",
  "reports.basis.shiftsShort": "vardiya",
  "reports.basis.24hShort": "24 sa",
  "reports.basis.workShort": "mesai",
  "reports.basis.shiftsHint": "Vardiya içindeki kontak süresi / vardiya süresi",
  "reports.basis.24hHint": "Kontak süresi / günün süresi",
  "reports.basis.workHint": "Mesai saatleri içindeki kontak süresi / mesai süresi",
  "reports.filter.basis": "Kullanım esası",
  "reports.basisOption.auto": "Varsayılan (vardiya varsa vardiya, yoksa mesai)",
  "reports.basisOption.shifts": "Vardiyaya göre",
  "reports.basisOption.work": "Mesai saatine göre",
  "reports.basisOption.workAt": "Mesai saatine göre ({hours})",
  "reports.basisOption.workVaries": "Mesai saatine göre (sahaya göre değişir)",
  "reports.filter.workHours": "Mesai saatleri",
  "reports.basisOption.24h": "Günün 24 saatine göre",
  "reports.range.tooLong": "En fazla 92 günlük aralık seçilebilir.",
  "reports.range.reversed": "Bitiş tarihi başlangıçtan önce olamaz.",
  "reports.range.invalid": "Geçerli bir tarih aralığı seçin.",
  "reports.range.routeTooLong": "Rota raporu en fazla 24 saatlik aralık gösterir.",
  "reports.filter.label": "Rapor filtreleri",
  "reports.filter.site": "Saha",
  "reports.filter.allSites": "Tüm sahalar",
  "reports.filter.vehicles": "Araçlar",
  "reports.filter.vehicle": "Araç",
  "reports.filter.allVehicles": "Tüm araçlar",
  "reports.filter.nVehicles": "{count} araç seçili",
  "reports.filter.clearVehicles": "Seçimi temizle",
  "reports.filter.chooseVehicle": "Araç seçin",
  "reports.filter.operator": "Operatör",
  "reports.filter.allOperators": "Tüm operatörler",
  "reports.filter.from": "Başlangıç tarihi",
  "reports.filter.to": "Bitiş tarihi",
  "reports.filter.dates": "Tarih aralığı",
  "reports.filter.types": "Olay türleri",
  "reports.filter.day": "Gün",
  "reports.filter.startTime": "Başlangıç saati",
  "reports.filter.endTime": "Bitiş saati",
  "reports.filter.window": "Zaman aralığı",
  "reports.group.impact": "Darbe",
  "reports.group.safety": "Güvenlik (koltuk, kemer, kartsız, müdahale)",
  "reports.group.geofence": "Saha sınırı",
  "reports.group.checklist": "Kontrol listesi",
  "reports.group.overload": "Aşırı yük",
  "reports.group.battery": "Akü",
  "reports.col.vehicle": "Araç",
  "reports.col.day": "Gün",
  "reports.col.ignition": "Kontak açık",
  "reports.col.moving": "Hareket",
  "reports.col.idle": "Rölanti",
  "reports.col.distanceKm": "Mesafe (km)",
  "reports.col.lifts": "Kaldırma",
  "reports.col.liftedKg": "Kaldırılan yük (kg)",
  "reports.col.utilisation": "Kullanım %",
  "reports.col.basis": "Kullanım esası",
  "reports.col.operators": "Operatörler",
  "reports.col.operator": "Operatör",
  "reports.col.time": "Zaman",
  "reports.col.type": "Tür",
  "reports.col.severity": "Önem",
  "reports.col.site": "Saha",
  "reports.col.status": "Durum",
  "reports.col.ackedAt": "Onay zamanı",
  "reports.col.ackNote": "Onay notu",
  "reports.col.zone": "Bölge",
  "reports.col.repeats": "Tekrar",
  "reports.col.lat": "Enlem",
  "reports.col.lon": "Boylam",
  "reports.col.speed": "Hız (km/sa)",
  "reports.col.ignitionOn": "Kontak",
  "reports.col.source": "Konum kaynağı",
  "reports.col.segment": "Bölüm",
  "reports.col.start": "Başlangıç",
  "reports.col.end": "Bitiş",
  "reports.col.duration": "Süre",
  "reports.col.maxSpeed": "En yüksek hız (km/sa)",
  "reports.col.shift": "Vardiya",
  "reports.col.shiftsUsed": "Kullanılan vardiya",
  "reports.col.shiftsChecked": "Doldurulan",
  "reports.col.missed": "Doldurulmayan",
  "reports.col.compliance": "Uyum %",
  "reports.col.submissions": "Gönderilen liste",
  "reports.col.faultsOpened": "Açılan arıza",
  "reports.col.faultsResolved": "Giderilen arıza",
  "reports.col.mttr": "Ort. giderme süresi (sa)",
  "reports.export.label": "Dışa aktar",
  "reports.export.csv": "CSV",
  "reports.export.csvSemicolon": "CSV (Türkçe Excel)",
  "reports.export.csvSemicolonHint": "Noktalı virgül ayraçlı ve ondalık virgüllü CSV; Türkçe Excel doğrudan açar.",
  "reports.export.xlsx": "Excel (XLSX)",
  "reports.export.pdf": "PDF",
  "reports.export.working": "Hazırlanıyor…",
  "reports.export.done": "Dosya hazırlandı ({rows} satır).",
  "reports.export.audit": "Her dışa aktarım kayıt altına alınır: kim, hangi rapor, hangi filtreler, kaç satır (1 yıl saklanır).",
  "reports.export.tooMany": "Dışa aktarım en fazla {max} satır içerebilir. Tarih aralığını veya filtreleri daraltın.",
  "reports.export.filters": "Filtreler",
  "reports.export.generatedAt": "Oluşturulma zamanı",
  "reports.export.generatedBy": "Oluşturan",
  "reports.export.timeZone": "Saat dilimi",
  "reports.export.page": "Sayfa {page} / {pages}",
  "reports.export.info": "Bilgi",
  "reports.export.pdfRowCap": "PDF ilk {shown} satırı gösterir (toplam {total}). Tamamı için Excel veya CSV indirin.",
  "reports.export.noRows": "Bu filtrelere uyan kayıt yok.",
  "reports.export.mapUnavailable": "Harita görüntüsü alınamadı; rota tablosu aşağıdadır.",
  "reports.usage.title": "Kullanım raporu",
  "reports.usage.slug": "kullanim",
  "reports.usage.subtitle": "Araç ve gün bazında kontak, hareket ve rölanti süreleri, mesafe, kaldırmalar, kullanım oranı ve operatörler.",
  "reports.usage.totalIgnition": "Toplam kontak açık",
  "reports.usage.totalMoving": "Toplam hareket",
  "reports.usage.totalDistance": "Toplam mesafe",
  "reports.usage.avgUtilisation": "Ortalama kullanım",
  "reports.usage.vehiclesUsed": "Kullanılan araç",
  "reports.usage.noLiftModule": "Bu araçta asansör ölçüm modülü yok",
  "reports.usage.rules": "Bir kaydın durumu bir sonraki kayda kadar, en fazla 2 dakika sürer; daha uzun boşluklar \"veri yok\" sayılır. Hareket: kontak açık ve hız en az 1 km/sa. Mesafe yalnızca doğru GNSS konumlarından hesaplanır; 40 km/sa'yi aşan sıçramalar ve durağan titreşim sayılmaz. Kullanım oranı, sahada vardiya varsa vardiya içindeki kontak süresinin vardiya süresine oranıdır, yoksa günün geçen süresine oranıdır. Kullanım, aracın bugünkü sahasına göre gösterilir.",
  "reports.events.title": "Olay raporu",
  "reports.events.slug": "olaylar",
  "reports.events.subtitle": "Alarm ve olaylar: tür, zaman, araç, operatör, saha, önem ve onay durumu.",
  "reports.events.rules": "Olaylar, olay anında aracın bulunduğu sahaya göre süzülür. Hız ihlali raporu Faz 2'de eklenecek.",
  "reports.route.title": "Rota raporu",
  "reports.route.slug": "rota",
  "reports.route.subtitle": "Tek araç, en fazla 24 saat: harita üzerinde rota, duraklar, saha sınırı olayları ve bölümler.",
  "reports.route.windowHint": "Saatler aracın sahasının saat dilimine göredir. Bitiş saati başlangıçtan önceyse aralık ertesi güne uzanır.",
  "reports.route.pickVehicle": "Rotasını görmek istediğiniz aracı seçin.",
  "reports.route.noPoints": "Bu aralıkta konum kaydı yok. Kapalı alanda GNSS konumu alınamayabilir.",
  "reports.route.map": "Harita",
  "reports.route.mapLabel": "{vehicle} rotası",
  "reports.route.mapError": "Harita yüklenemedi. Bölümler tablosu aşağıda.",
  "reports.route.legendTrack": "Rota",
  "reports.route.legendStop": "Durak (2 dakikadan uzun)",
  "reports.route.legendEvent": "Saha sınırı olayı",
  "reports.route.start": "Başlangıç",
  "reports.route.end": "Bitiş",
  "reports.route.drive": "Sürüş",
  "reports.route.stop": "Duruş",
  "reports.route.segments": "Bölümler",
  "reports.route.points": "Konum noktası",
  "reports.route.drivenDistance": "Sürüş mesafesi",
  "reports.route.drivingTime": "Sürüş süresi",
  "reports.route.stopsCount": "Durak sayısı",
  "reports.route.geofenceEvents": "Rotadaki saha sınırı olayları",
  "reports.route.dropped": "Gerçek dışı {count} konum sıçraması (40 km/sa üzeri) rotadan çıkarıldı.",
  "reports.route.droppedLabel": "Çıkarılan konum sıçraması",
  "reports.route.rules": "Durak: hızın 1 km/sa altında kaldığı veya kontağın kapalı olduğu, en az 2 dakika süren bölüm. Excel ve CSV tüm konum noktalarını, PDF harita görüntüsünü ve bölümleri içerir.",
  "reports.checklist.title": "Kontrol listesi uyum raporu",
  "reports.checklist.slug": "kontrol-listesi-uyum",
  "reports.checklist.subtitle": "Araç ve vardiya bazında kullanılan vardiyalar, doldurulan ve doldurulmayan kontrol listeleri, açılan ve giderilen arızalar.",
  "reports.checklist.noShifts": "Vardiya tanımı yok",
  "reports.checklist.totalCompliance": "Genel uyum",
  "reports.heatmap.title": "Isı haritası",
  "reports.heatmap.slug": "isi-haritasi",
  "reports.heatmap.subtitle": "Sahada olayların toplandığı ve araçların en çok hareket ettiği yerler.",
  "reports.heatmap.mode": "Gösterim",
  "reports.heatmap.mode.events": "Olaylar",
  "reports.heatmap.mode.usage": "Kullanım",
  "reports.heatmap.events": "Olay sayısı",
  "reports.heatmap.weight": "Ağırlıklı toplam",
  "reports.heatmap.points": "Hareketli konum noktası",
  "reports.heatmap.vehicles": "Araç sayısı",
  "reports.heatmap.cells": "Hücre (~{size} m)",
  "reports.heatmap.unlocated": "Konumu olmayan olay",
  "reports.heatmap.map": "Harita",
  "reports.heatmap.mapLabel": "Isı haritası: {mode}",
  "reports.heatmap.mapError": "Harita yüklenemedi. Özet bilgiler yukarıda; hücre listesini CSV veya Excel olarak indirebilirsiniz.",
  "reports.heatmap.mapUnavailable": "Harita görüntüsü alınamadı; özet ve en yoğun hücreler aşağıdadır.",
  "reports.heatmap.legend": "Yoğunluk",
  "reports.heatmap.legendLow": "Düşük",
  "reports.heatmap.legendHigh": "Yüksek",
  "reports.heatmap.legendAria": "Renk skalası: maviden kırmızıya, düşükten yükseğe yoğunluk",
  "reports.heatmap.zoomHint": "Yakınlaştırdıkça tek tek hücreler görünür.",
  "reports.heatmap.noEvents": "Bu dönemde konumu bilinen olay yok.",
  "reports.heatmap.noUsage": "Bu dönemde hareket kaydı yok. Harita için araçlardan GNSS konumu gelmiş olmalıdır.",
  "reports.heatmap.truncated": "En yoğun {max} hücre gösteriliyor (toplam {total}). Ayrıntı için tarih aralığını veya araç seçimini daraltın.",
  "reports.heatmap.rangeTooLong": "Isı haritası en fazla 31 günlük aralık gösterir.",
  "reports.heatmap.tooLarge": "Kullanım ısı haritası en fazla {max} araç-gün işler (ör. 31 gün × 12 araç veya 7 gün × 57 araç). Tarih aralığını veya araç seçimini daraltın.",
  "reports.heatmap.rules.events": "Olaylar, olay anında aracın bulunduğu sahaya göre süzülür. Darbeler seviyesine göre (1–3) ağırlık alır, diğer olaylar 1 sayılır. Hücreler yaklaşık {size} m boyundadır. Kontrol listesi alarmlarının konumu yoktur, haritaya alınmaz. Konumu olmayan diğer olaylar (ör. kartsız çalıştırma) haritaya girmez, ayrıca sayılır.",
  "reports.heatmap.rules.usage": "Kontak açık ve hızı en az 1 km/sa olan, cihaz saati doğrulanmış GNSS konumları sayılır (doğruluk bilgisi varsa en fazla 15 m); saniyelik iz noktaları dahildir. Araçlar bugünkü sahalarına göre süzülür. Hücreler yaklaşık {size} m boyundadır.",
  "reports.heatmap.kvkk": "Haritada operatör veya kart bilgisi yoktur; yalnızca toplu konum yoğunluğu gösterilir.",
  "reports.heatmap.sheetCells": "Hücreler",
  "reports.heatmap.sheetTop": "En yoğun {count} hücre",
  "reports.heatmap.col.rank": "Sıra",
  "reports.heatmap.col.weight": "Ağırlık",
  "reports.heatmap.col.events": "Olay",
  "reports.heatmap.col.points": "Nokta",
  "reports.checklist.rules": "Uyum: aracın kullanıldığı vardiyalardan kontrol listesi doldurulanların oranı (vardiya başlangıcından 30 dakika önce dahil). Gönderim ve arızalar, gönderim anındaki sahaya göre süzülür; vardiya kullanımı aracın bugünkü sahasına göre hesaplanır.",

  "sites.title": "Sahalar",
  "sites.subtitle": "{count} saha ve alt birim",
  "sites.empty": "Bu kiracıda henüz saha tanımlı değil.",

  "site.name": "Ad",
  "site.kind": "Tür",
  "site.address": "Adres",
  "site.vehicles": "Araç",
  "site.childCount": "Alt birim",
  "site.noAddress": "Adres girilmemiş",
  "site.childSites": "Alt birimler",
  "site.noChildren": "Bu sahanın alt birimi yok.",
  "site.vehiclesTitle": "Araçlar",
  "site.vehiclesSummary": "{direct} bu birimde · {total} alt birimlerle birlikte",
  "site.noVehicles": "Bu birimde ve alt birimlerinde kayıtlı araç yok.",
  "site.notFound": "Saha bulunamadı veya erişim yetkiniz yok.",

  "siteKind.site": "Saha",
  "siteKind.warehouse": "Depo",
  "siteKind.department": "Bölüm",
  "siteKind.zone": "Bölge",

  "vehicle.fleetNo": "Filo no",
  "vehicle.type": "Tür",
  "vehicle.power": "Enerji",
  "vehicle.makeModel": "Marka / model",
  "vehicle.make": "Marka",
  "vehicle.model": "Model",
  "vehicle.serialNo": "Seri no",
  "vehicle.battery": "Akü (V)",
  "vehicle.batteryValue": "{value} V",
  "vehicle.device": "Cihaz",
  "vehicle.noDevice": "Bağlı değil",
  "vehicle.status": "Durum",
  "vehicle.site": "Saha",
  "vehicle.active": "Aktif",
  "vehicle.notFound": "Araç bulunamadı veya erişim yetkiniz yok.",

  "vehicleType.forklift": "Forklift",
  "vehicleType.reach_truck": "Reach truck",
  "vehicleType.order_picker": "Sipariş toplayıcı",
  "vehicleType.pallet_truck": "Akülü transpalet",
  "vehicleType.other": "Diğer",

  "power.electric": "Elektrikli",
  "power.diesel": "Dizel",
  "power.lpg": "LPG",

  "status.ready": "Cihaz bağlı",
  "status.no_device": "Cihaz bekliyor",
  "status.inactive": "Pasif",

  "vehicles.title": "Araçlar",
  "vehicles.count": "{shown} / {total} araç",
  "vehicles.filterSite": "Saha",
  "vehicles.filterType": "Tür",
  "vehicles.filterSearch": "Ara",
  "vehicles.all": "Tümü",
  "vehicles.clear": "Filtreleri temizle",
  "vehicles.empty": "Filtrelere uyan araç yok.",
  "vehicles.filtersLabel": "Araç filtreleri",

  "vehicleDetail.tabsLabel": "Araç bölümleri",
  "vehicleDetail.tab.general": "Genel",
  "vehicleDetail.tab.live": "Canlı durum",
  "vehicleDetail.tab.events": "Olaylar",
  "vehicleDetail.tab.operators": "Yetkili operatörler",
  "vehicleDetail.tab.device": "Cihaz",
  "vehicleDetail.tab.audit": "Denetim",
  "vehicleDetail.identity": "Araç kimliği",
  "vehicleDetail.assignment": "Konum ve cihaz",
  "vehicleDetail.tabSoon": "“{tab}” bölümü sonraki sprintlerde eklenecek. Şimdilik gösterilecek veri yok.",
  // Sprint 7a: battery and lift modules (ICD v0.2 section 9, ADR 0017)
  "modules.alarmNoBlock": "Araç, sürüş veya kaldırma engellenmez; akü ve asansör alarmları yalnızca bildirimdir.",
  "modules.battery.chargedKwh": "{value} kWh",
  "modules.value.kgPerBar": "{value} kg/bar",
  "modules.lift.noLoad": "yük bilgisi yok",
  "modules.lift.estimated": "tahmini",
  "modules.lift.estimatedHint": "Cihaz yük göndermedi; bulut, araç ayarlarıyla tahmin etti.",
  "modules.batType.lead_acid": "Kurşun asit",
  "modules.batType.lithium": "Lityum",
  "modules.settings.title": "Modül ayarları",
  "modules.settings.description": "Akü türü, kapasite, kalibrasyon katsayısı ve kaldırma eşiği cihaza gönderilir; cihaz şarj yüzdesini ve yükü bunlarla hesaplar. Değişiklikler bir dakika içinde gönderilir.",
  "modules.settings.batType": "Akü türü",
  "modules.settings.batAh": "Akü kapasitesi",
  "modules.settings.batAhLabel": "Akü kapasitesi (Ah)",
  "modules.settings.kgPerBar": "Kalibrasyon katsayısı",
  "modules.settings.kgPerBarLabel": "Kalibrasyon katsayısı (kg/bar)",
  "modules.settings.kgPerBarHint": "Bilinen yükle yapılan kalibrasyondan; cihaz yükü bununla tahmin eder.",
  "modules.settings.threshold": "Kaldırma eşiği",
  "modules.settings.thresholdLabel": "Kaldırma eşiği (bar)",
  "modules.settings.thresholdHint": "Basınç bunu aşınca kaldırma döngüsü başlar.",
  "modules.settings.emptyBarLabel": "Boş çatal basıncı (bar)",
  "modules.settings.emptyBarHint": "Cihaza gönderilmez; yalnızca cihaz yük göndermediğinde bulutun tahmininde kullanılır.",
  "modules.settings.ratedLabel": "Nominal kapasite (kg)",
  "modules.settings.range": "{min} ile {max} arasında bir sayı girin.",
  "modules.settings.delivery": "Cihaza iletim",
  "modules.settings.note": "Ayarlar yalnızca ölçümü etkiler; araç, sürüş veya kaldırma hiçbir koşulda engellenmez.",
  "modules.delivery.none": "Ayar yok",
  "modules.delivery.pending": "Cihaz onayı bekleniyor",
  "modules.delivery.acked": "Cihaz onayladı",
  "modules.delivery.failed": "Gönderilemedi",
  "modules.delivery.kept": "Cihaz son değerleri saklıyor",
  "modules.settings.locked": "Cihaz son değeri saklar; alan boşaltılamaz, yeni değer girin.",
  "error.module_setting_locked": "Cihaza gönderilmiş bir ayar boşaltılamaz; cihaz son değeri saklar. Yeni bir değer girin.",
  "modules.loadError": "Akü ve asansör verisi yüklenemedi.",
  "modules.value.percent": "%{value}",
  "modules.value.volts": "{value} V",
  "modules.value.amps": "{value} A",
  "modules.value.celsius": "{value} °C",
  "modules.value.kg": "{value} kg",
  "modules.value.bar": "{value} bar",
  "modules.value.meters": "{value} m",
  "modules.battery.title": "Akü",
  "modules.battery.soc": "Şarj durumu",
  "modules.battery.voltage": "Gerilim",
  "modules.battery.current": "Akım",
  "modules.battery.currentHint": "+ şarj, − deşarj",
  "modules.battery.temperature": "Sıcaklık",
  "modules.battery.state": "Durum",
  "modules.battery.lastCharge": "Son şarj",
  "modules.battery.socRange": "%{from} → %{to}",
  "modules.battery.chargedAh": "{value} Ah",
  "modules.battery.noCharge": "Son 7 günde şarj kaydı yok",
  "modules.battery.chargingSince": "Şarj başladı: {when}",
  "modules.battery.incomplete": "eksik kayıt",
  "modules.battery.readingAt": "Son ölçüm: {when}",
  "modules.battery.noReading": "Henüz akü ölçümü gelmedi.",
  "modules.battery.low": "Şarj düşük: aracı şarja alın.",
  "modules.battery.sparkline": "Son 24 saatte şarj durumu",
  "modules.battery.sparklineRange": "En düşük %{min} · en yüksek %{max}",
  "modules.battery.sparklineEmpty": "Son 24 saatte akü verisi yok.",
  "modules.battery.nominal": "{value} V akü",
  "modules.state.charging": "Şarj oluyor",
  "modules.state.discharging": "Kullanımda",
  "modules.state.resting": "Beklemede",
  "modules.state.unknown": "Bilinmiyor",
  "modules.lift.title": "Asansör (kaldırma)",
  "modules.lift.today": "Bugün",
  "modules.lift.todayValue": "{lifts} kaldırma · {overloads} aşırı yük",
  "modules.lift.last": "Son kaldırmalar",
  "modules.lift.colTime": "Zaman",
  "modules.lift.colLoad": "Yük",
  "modules.lift.colHeight": "Yükseklik",
  "modules.lift.colPressure": "Basınç",
  "modules.lift.overloadBadge": "Aşırı yük",
  "modules.lift.none": "Henüz kaldırma kaydı yok.",
  "modules.lift.capacity": "Nominal kapasite",
  "modules.lift.estimateNote": "Yük, cihazın kalibrasyon katsayısıyla hesapladığı tahmindir (yaklaşık ±%5). Aşırı yük yalnızca bildirilir; araç veya kaldırma engellenmez.",
  "map.detail.soc": "Akü şarjı",
  "map.socBadge": "Akü %{value}",

  "users.title": "Kullanıcılar ve roller",
  "users.subtitle": "{count} kullanıcı bu kiracıya erişebiliyor",
  "users.name": "Ad",
  "users.email": "E-posta",
  "users.role": "Rol",
  "users.scope": "Erişim kapsamı",
  "users.allSites": "Tüm sahalar",
  "users.siteCount": "{count} saha",
  "users.empty": "Bu kiracıda kullanıcı yok.",
  "users.rolesTitle": "Roller",
  "users.roleHelp.viewer": "Ekranları görüntüler, değişiklik yapamaz.",
  "users.roleHelp.safety": "Darbe ve olayları izler, İSG raporlarına erişir.",
  "users.roleHelp.fleet_manager": "Araç, cihaz, operatör ve yetkileri yönetir.",
  "users.roleHelp.admin": "Kullanıcıları, rolleri ve kiracı ayarlarını yönetir.",
  "users.alarmMail.title": "Alarm e-postaları",
  "users.alarmMail.copyAdmins": "Yöneticiler her alarmın kopyasını alsın",
  "users.alarmMail.hint": "Alarm e-postaları normalde İSG sorumlusuna ve filo yöneticisine gider; yöneticiler yalnızca bu rollerde e-posta alabilecek kimse yoksa alır. Açıkken yöneticiler de her alarmın kopyasını alır.",
  "users.alarmMail.readOnly": "Bu ayarı yalnızca yöneticiler değiştirebilir.",

  "access.title": "Erişim yok",
  "access.body": "Bu ekranı görüntülemek için yetkiniz bulunmuyor. Gerekirse kiracı yöneticinizle görüşün.",

  "soon.title": "Bu ekran yakında",
  "soon.body": "{feature} ekranı sonraki sprintlerde eklenecek. Şu an gösterilecek veri yok.",
  "soon.unknownTitle": "Sayfa bulunamadı",
  "soon.unknownBody": "Bu adreste bir ekran yok. Menüden devam edebilirsiniz.",

  "common.cancel": "Vazgeç",
  "common.close": "Kapat",
  "common.save": "Kaydet",
  "common.edit": "Düzenle",
  "common.delete": "Sil",
  "common.ok": "Tamam",
  "common.working": "İşleniyor…",
  "common.actions": "İşlemler",
  "common.copy": "Kopyala",
  "common.copied": "Kopyalandı",
  "common.copyFailed": "Kopyalanamadı",

  "form.optional": "isteğe bağlı",
  "form.required": "Bu alan zorunlu.",
  "form.tooLong": "En fazla {max} karakter olabilir.",
  "form.select": "Seçin…",
  "form.chooseOne": "Bir seçim yapın.",

  "nav.inventory": "Cihaz envanteri",

  "error.invalid_credentials": "E-posta veya şifre hatalı.",
  "error.captcha_failed": "Güvenlik doğrulaması başarısız oldu. Tekrar deneyin.",
  "error.invalid_code": "Kod hatalı veya süresi dolmuş.",
  "error.not_configured": "Sunucu bağlantısı henüz yapılandırılmadı.",
  "error.unknown": "İşlem tamamlanamadı. Bilgileri kontrol edip tekrar deneyin.",
  "error.forbidden": "Bu işlem için yetkiniz yok.",
  "error.invalid_device_id": "Cihaz numarası geçersiz. Büyük harf, rakam ve tire kullanın (ör. FTS-000123).",
  "error.device_exists": "Bu cihaz numarası zaten kayıtlı.",
  "error.device_not_found": "Cihaz bulunamadı.",
  "error.device_revoked": "Bu cihaz engellenmiş, araca bağlanamaz.",
  "error.device_busy": "Bu cihaz zaten başka bir araca bağlı. Önce o araçtan ayırın.",
  "error.vehicle_busy": "Bu araçta zaten bir cihaz var. Önce mevcut cihazı ayırın.",
  "error.vehicle_inactive": "Pasif araçlara cihaz bağlanamaz. Önce aracı aktif yapın.",
  "error.tenant_mismatch": "Bu cihaz firmanıza ait değil.",
  "error.claim_invalid": "Cihaz numarası ya da etiket kodu hatalı veya cihaz daha önce eklenmiş.",
  "error.invalid_email": "Geçerli bir e-posta adresi girin.",
  "error.invalid_scope": "Erişim kapsamı geçersiz. Yöneticiler tüm sahalara erişir; saha seçimi yalnızca diğer roller için yapılabilir.",
  "error.already_member": "Bu kişi zaten bu firmanın kullanıcısı.",
  "error.invitation_invalid": "Bu davet artık geçerli değil.",
  "error.wrong_email": "Bu davet başka bir e-posta adresine gönderilmiş. Davetin gönderildiği adresle giriş yapın.",
  "error.scope_changed": "Davetteki sahalardan biri silinmiş. Yöneticinizden yeni bir davet isteyin.",
  "error.site_is_last_scope": "Bu saha, bir kullanıcının erişebildiği tek saha. Silmeden önce o kullanıcının erişim kapsamını değiştirin.",
  "error.vehicle_has_history": "Bu aracın kayıtlı verisi var, silinemez. Kullanımdan kaldırmak için aracı pasif yapın.",
  "error.rate_limited": "Bu işlem çok sık yapıldı. Bir dakika bekleyip tekrar deneyin. Aynı davet en fazla 5 kez e-postayla gönderilebilir; sınıra ulaştıysanız yeni bir davet oluşturun.",
  "error.unauthorized": "Oturumunuzun süresi dolmuş. Lütfen yeniden giriş yapın.",
  "error.bad_request": "Sunucu isteği kabul etmedi. Sayfayı yenileyip tekrar deneyin.",
  "error.not_found": "İstenen kayıt sunucuda bulunamadı.",
  "error.broker_error": "MQTT sunucusuna ulaşılamadı. Biraz sonra tekrar deneyin.",
  "error.mail_error": "E-posta gönderilemedi. Biraz sonra tekrar deneyin ya da bağlantıyı kopyalayıp kendiniz iletin.",

  "login.sendLink": "Giriş bağlantısı gönder",

  "deviceState.online": "Çevrim içi",
  "deviceState.offline": "Çevrim dışı",
  "deviceState.revoked": "Engellendi",

  "device.id": "Cihaz no",
  "device.vehicle": "Araç",
  "device.status": "Durum",
  "device.lastSeen": "Son bağlantı",
  "device.neverSeen": "Henüz bağlanmadı",
  "device.firmware": "Yazılım",
  "device.claimedAt": "Eklenme",
  "device.imei": "IMEI",
  "device.iccid": "ICCID",
  "device.unpaired": "Araca bağlı değil",

  "devices.title": "Cihazlar",
  "devices.subtitle": "{count} cihaz · {paired} tanesi araca bağlı",
  "devices.add": "Cihaz ekle",
  "devices.pair": "Araca bağla",
  "devices.unpair": "Araçtan ayır",
  "devices.claimed": "{device} firmanıza eklendi.",
  "devices.empty": "Henüz cihaz yok.",
  "devices.emptyManager": "Telematik üniteyi etiketindeki kodla “Cihaz ekle” üzerinden ekleyin, sonra bir araca bağlayın.",
  "devices.emptyViewer": "Görebildiğiniz araçlara bağlı cihaz bulunmuyor.",
  "devices.readOnly": "Cihaz eklemek ve araçlara bağlamak filo yöneticisi yetkisi gerektirir.",

  "claim.title": "Cihaz ekle",
  "claim.description": "Size gönderilen telematik üniteyi firmanıza ekleyin. Cihaz numarası ve etiket kodu, cihazın üzerindeki etikette yazar.",
  "claim.code": "Etiket kodu",
  "claim.codeHint": "12 karakterlik kod (ör. 0A1B-2C3D-4E5F). Tire ve boşluklar önemli değil. Her kod yalnızca bir kez kullanılabilir.",
  "claim.codeFormat": "Kod 12 karakter olmalı (0–9, A–F).",
  "claim.submit": "Cihazı ekle",
  "claim.demoHint": "Demo için örnek etiket kodları: {codes}",

  "pair.titleDevice": "{device} cihazını araca bağla",
  "pair.titleVehicle": "{vehicle} aracına cihaz bağla",
  "pair.description": "Bir araçta aynı anda yalnızca bir cihaz olabilir. Hangi cihazın hangi araçta olduğu geçmişiyle saklanır.",
  "pair.vehicle": "Araç",
  "pair.vehicleHint": "Yalnızca aktif ve cihazı olmayan araçlar listelenir.",
  "pair.device": "Cihaz",
  "pair.noVehicles": "Bağlanabilecek araç yok: tüm aktif araçlarda zaten bir cihaz var.",
  "pair.noDevices": "Bağlanabilecek cihaz yok. Önce “Cihazlar” ekranından bir cihaz ekleyin.",
  "pair.submit": "Bağla",

  "unpair.title": "Cihazı araçtan ayır",
  "unpair.body": "{device} cihazı {vehicle} aracından ayrılacak. Cihaz firmanızda kalır ve başka bir araca bağlanabilir.",
  "unpair.submit": "Ayır",

  "vehicleDevice.title": "Telematik cihaz",
  "vehicleDevice.none": "Bu araca bağlı cihaz yok.",
  "vehicleDevice.inactive": "Araç pasif olduğu için cihaz bağlanamaz.",
  "vehicleDevice.pair": "Cihaz bağla",

  "inventory.title": "Cihaz envanteri",
  "inventory.subtitle": "{total} kayıtlı cihaz · {inventory} tanesi envanterde",
  "inventory.register": "Cihaz kaydet",
  "inventory.tenant": "Firma",
  "inventory.inStock": "Envanterde",
  "inventory.onVehicle": "araca bağlı",
  "inventory.rotate": "Gizli anahtarı yenile",
  "inventory.revoke": "Engelle",
  "inventory.unrevoke": "Engeli kaldır",
  "inventory.release": "Envantere geri al",
  "inventory.filter": "Durum",
  "inventory.filterInventory": "Envanterde",
  "inventory.filterClaimed": "Firmaya eklenmiş",
  "inventory.filterRevoked": "Engellenmiş",
  "inventory.filtersLabel": "Envanter filtreleri",
  "inventory.searchPlaceholder": "Cihaz no, IMEI, ICCID",
  "inventory.empty": "Henüz kayıtlı cihaz yok.",
  "inventory.noMatch": "Filtrelere uyan cihaz yok.",
  "inventory.note": "Bu ekranı yalnızca Expartise platform yöneticileri görür. Gizli anahtarlar ve etiket kodları veritabanında yalnızca özet (hash) olarak tutulur, sonradan görüntülenemez.",

  "register.title": "Cihaz kaydet",
  "register.description": "Her satıra bir cihaz yazın. Kayıt sırasında her cihaz için bir gizli anahtar ve bir etiket kodu üretilir.",
  "register.lines": "Cihazlar",
  "register.linesHint": "Biçim: CİHAZ_NO[,IMEI[,ICCID]], ör. FTS-000123,350000000000123",
  "register.lineErrors": "Hatalı satırlar",
  "register.lineNo": "Satır {line}:",
  "register.lineInvalid": "cihaz numarası geçersiz (büyük harf, rakam ve tire; 3–32 karakter)",
  "register.lineDuplicate": "bu cihaz numarası listede ya da kayıtlarda zaten var",
  "register.lineTooMany": "en fazla üç alan olabilir",
  "register.empty": "En az bir cihaz girin.",
  "register.count": "{count} cihaz kaydedilecek",
  "register.submit": "Kaydet",
  "register.resultTitle": "{count} cihaz kaydedildi",
  "register.secretWarning": "Gizli anahtarlar ve etiket kodları yalnızca şimdi gösteriliyor. Pencereyi kapatmadan önce CSV olarak indirin ya da kopyalayın; sonradan tekrar görüntülenemez.",
  "register.partialFailure": "{device} kaydedilemedi: {reason} Bu satır ve sonrakiler işlenmedi.",
  "register.downloadCsv": "CSV indir",
  "register.labelHint": "Gizli anahtar cihaza yüklenir. Etiket kodu cihazın etiketine basılır; müşteri cihazı eklerken bu kodu kullanır.",
  "register.brokerNotSynced": "Kaydedildi ama MQTT sunucusuna aktarılamadı: {devices}. Bu cihazlar gösterilen anahtarla bağlanamaz; kurulumdan önce envanterden anahtarlarını yenileyin.",

  "secret.secret": "Gizli anahtar",
  "secret.claimCode": "Etiket kodu",
  "secret.copySecret": "{device} gizli anahtarını kopyala",
  "secret.copyCode": "{device} etiket kodunu kopyala",
  "secret.savedClose": "Kaydettim, kapat",

  "rotate.title": "{device} için gizli anahtar yenilensin mi?",
  "rotate.body": "Yeni bir gizli anahtar üretilecek. Eski anahtar hemen geçersiz olur; yeni anahtar yüklenene kadar cihaz bağlanamaz.",
  "rotate.submit": "Anahtarı yenile",
  "rotate.resultTitle": "{device} için yeni gizli anahtar",
  "rotate.warning": "Bu anahtar yalnızca şimdi gösteriliyor. Kopyalayıp cihaza yükleyin; sonradan tekrar görüntülenemez.",
  "rotate.brokerNotSynced": "Yeni anahtar kaydedildi ama MQTT sunucusuna aktarılamadı; cihaz bu anahtarla henüz bağlanamaz. Biraz sonra anahtarı yeniden yenileyin.",

  "revoke.title": "{device} engellensin mi?",
  "revoke.body": "Engellenen cihaz sunucuya bağlanamaz ve gönderdiği veriler kaydedilmez. Araç bağlantısı korunur; engeli daha sonra kaldırabilirsiniz.",
  "revoke.unTitle": "{device} için engel kaldırılsın mı?",
  "revoke.unBody": "Cihaz yeniden bağlanıp veri gönderebilir. Sunucu yapılandırmasına göre yeni bir gizli anahtar da üretilebilir; üretilirse yalnızca bir kez gösterilir.",
  "revoke.syncTitle": "MQTT sunucusu güncellenemedi",
  "release.brokerNotSynced": "{device} envantere alındı ve anahtarı iptal edildi, ancak MQTT sunucusu güncellenemedi; cihaz mevcut bağlantısını koruyabilir. Cihazı engelleyip engeli tekrar kaldırarak sunucuyu güncelleyebilirsiniz.",
  "revoke.brokerNotSynced": "{device} engellendi ve gönderdiği veriler artık kaydedilmiyor. Ancak MQTT sunucusu güncellenemedi; cihaz sunucuya bağlı kalmaya devam edebilir.",
  "revoke.unBrokerNotSynced": "{device} için engel kaldırıldı ama bu değişiklik MQTT sunucusuna aktarılamadı; cihaz henüz bağlanamayabilir. Bağlanabilmesi için anahtarını yenileyin.",
  "revoke.unSecretWarning": "Engel kaldırıldı. Eski anahtar artık geçersiz; bu yeni anahtarı cihaza yükleyin. Anahtar yalnızca şimdi gösteriliyor, sonradan tekrar görüntülenemez.",

  "release.title": "{device} envantere geri alınsın mı?",
  "release.body": "Cihaz {tenant} firmasından alınır ve bağlı olduğu araçtan ayrılır. Yeni bir etiket kodu üretilir, eskisi geçersiz olur. Cihazın gizli anahtarı da iptal edilir; başka bir müşteriye vermeden önce anahtarı yenileyip cihaza yükleyin.",
  "release.submit": "Envantere al",
  "release.resultTitle": "{device} envantere alındı",
  "release.warning": "Yeni etiket kodu yalnızca şimdi gösteriliyor. Cihazın etiketini bu kodla yenileyin.",

  "sites.add": "Saha ekle",
  "site.addChild": "Alt birim ekle",
  "site.parent": "Üst birim",
  "site.noParent": "Yok (ana saha)",
  "site.parentRequired": "Bir üst birim seçin.",
  "site.parentHintManager": "Ana saha açmak kiracı yöneticisi yetkisi gerektirir.",
  "site.rootLocked": "Ana sahaların yerini yalnızca kiracı yöneticisi değiştirebilir.",
  "site.lat": "Enlem",
  "site.lon": "Boylam",
  "site.latHint": "−90 ile 90 arası, ör. 40.7654",
  "site.lonHint": "−180 ile 180 arası, ör. 29.9432",
  "site.latInvalid": "Enlem −90 ile 90 arasında bir sayı olmalı.",
  "site.lonInvalid": "Boylam −180 ile 180 arasında bir sayı olmalı.",
  "site.coordPair": "Enlem ve boylamı birlikte girin.",
  "siteForm.createTitle": "Yeni saha veya birim",
  "siteForm.editTitle": "Sahayı düzenle",
  "siteDelete.title": "“{name}” silinsin mi?",
  "siteDelete.body": "Bu işlem geri alınamaz.",
  "siteDelete.hasChildren": "Bu sahanın alt birimleri var. Önce alt birimleri silin ya da başka bir sahaya taşıyın.",
  "siteDelete.hasVehicles": "Bu sahada kayıtlı araçlar var. Önce araçları başka bir sahaya taşıyın.",

  "vehicles.add": "Araç ekle",
  "vehicleForm.createTitle": "Yeni araç",
  "vehicleForm.editTitle": "{fleetNo} aracını düzenle",
  "vehicleForm.fleetNoTaken": "Bu filo numarası zaten kullanılıyor.",
  "vehicleForm.noBattery": "Belirtilmedi",
  "vehicleForm.batteryHint": "Elektrikli araçlarda akü gerilimi.",
  "vehicleForm.activeHint": "Kullanımdan çıkan araçları pasif yapın. Pasif araçlara cihaz bağlanamaz.",
  "vehicleForm.unauthorizedStart": "Kartsız çalıştırma alarmı",
  "vehicleForm.unauthorizedStartHint": "Kart okuyucusu takılı olmayan araçta kapatın.",
  "vehicleForm.unauthorizedStartNoReader": "Bu araca bağlı cihazda kart okuyucu yok, bu yüzden bu alarm oluşmaz.",

  "tenantForm.open": "Yeni firma",
  "tenantForm.title": "Yeni firma",
  "tenantForm.description": "Yeni bir müşteri firması (kiracı) açın. Sahaları ve kullanıcıları ardından ekleyebilirsiniz.",
  "tenantForm.name": "Firma adı",
  "tenantForm.nameTooShort": "Firma adı en az 2 karakter olmalı.",
  "tenantForm.slug": "Kısa ad",
  "tenantForm.slugHint": "Firmayı tanımlayan benzersiz kısa ad: küçük harf, rakam ve tire.",
  "tenantForm.slugInvalid": "Kısa ad küçük harf ya da rakamla başlamalı ve yalnızca küçük harf, rakam ve tire içermeli (2–41 karakter).",
  "tenantForm.slugTaken": "Bu kısa ad başka bir firmada kullanılıyor.",
  "tenantForm.submit": "Firmayı aç",

  "members.you": "(siz)",
  "members.changeRole": "Rolü değiştir",
  "members.remove": "Kullanıcıyı çıkar",
  "members.roleTitle": "{name} için rol",
  "members.adminNeedsAllSites": "önce saha kısıtını kaldırın",
  "members.removeTitle": "{name} çıkarılsın mı?",
  "members.removeBody": "Kullanıcı {tenant} firmasına erişimini kaybeder. Hesabı silinmez; gerekirse yeniden davet edebilirsiniz.",
  "members.adminSeatsNote": "Yönetici atamak, bir yöneticinin rolünü değiştirmek ya da yöneticiyi çıkarmak için Expartise ile iletişime geçin.",

  "invite.open": "Kullanıcı davet et",
  "invite.title": "Kullanıcı davet et",
  "invite.description": "{tenant} için bir davet bağlantısı oluşturun.",
  "invite.selectedSites": "Seçili sahalar",
  "invite.chooseSites": "En az bir saha seçin.",
  "invite.adminAllSites": "Yöneticiler her zaman tüm sahalara erişir.",
  "invite.scopeHint": "Bir sahaya erişim, o sahanın tüm alt birimlerini de kapsar.",
  "invite.submit": "Davet oluştur",
  "invite.createdTitle": "Davet oluşturuldu",
  "invite.createdBody": "{email} adresi {role} rolüyle davet edildi. Bağlantı {date} tarihine kadar geçerli.",
  "invite.link": "Davet bağlantısı",
  "invite.copyLink": "Davet bağlantısını kopyala",
  "invite.sendEmail": "E-postayla gönder",
  "invite.sendAgain": "Tekrar gönder",
  "invite.sending": "Gönderiliyor…",
  "invite.emailSent": "Davet e-postası {email} adresine gönderildi.",
  "invite.emailSentDemo": "(Demo modunda gerçek e-posta gönderilmez.)",
  "invite.sendHint": "Daveti buradan e-postayla gönderebilir ya da bağlantıyı kopyalayıp kendiniz iletebilirsiniz. Bağlantı yalnızca şimdi gösteriliyor; kaybederseniz yeni bir davet oluşturun.",

  "invitations.title": "Davetler",
  "invitations.empty": "Bu firmada henüz davet yok.",
  "invitations.status": "Durum",
  "invitations.expires": "Bitiş",
  "invitations.revoke": "İptal et",
  "invitations.revokeTitle": "{email} daveti iptal edilsin mi?",
  "invitations.revokeBody": "Bağlantı hemen geçersiz olur. Gerekirse yeni bir davet oluşturabilirsiniz.",
  "invitationStatus.pending": "Bekliyor",
  "invitationStatus.accepted": "Kabul edildi",
  "invitationStatus.revoked": "İptal edildi",
  "invitationStatus.expired": "Süresi doldu",

  "acceptInvite.title": "Davet",
  "acceptInvite.summary": "{tenant} sizi Forklift Takip Sistemi konsoluna {role} olarak davet etti.",
  "acceptInvite.expires": "Davet {date} tarihine kadar geçerli.",
  "acceptInvite.loadErrorBody": "Davet bilgileri alınamadı. Bağlantınızı kontrol edip sayfayı yenileyin.",
  "acceptInvite.unknownTitle": "Davet bulunamadı",
  "acceptInvite.unknownBody": "Bağlantı hatalı ya da eksik kopyalanmış olabilir. Sizi davet eden kişiden bağlantıyı yeniden isteyin.",
  "acceptInvite.acceptedTitle": "Bu davet zaten kabul edilmiş",
  "acceptInvite.acceptedBody": "{tenant} hesabınıza bağlı. Konsola giriş yaparak devam edebilirsiniz.",
  "acceptInvite.revokedTitle": "Bu davet iptal edilmiş",
  "acceptInvite.revokedBody": "Erişime hâlâ ihtiyacınız varsa {tenant} yöneticinizden yeni bir davet isteyin.",
  "acceptInvite.expiredTitle": "Bu davetin süresi dolmuş",
  "acceptInvite.expiredBody": "Davetler 7 gün geçerlidir. {tenant} yöneticinizden yeni bir davet isteyin.",
  "acceptInvite.signInLinkIntro": "Daveti kabul etmek için davetin gönderildiği e-posta adresini girin; size bir giriş bağlantısı gönderelim.",
  "acceptInvite.signInPasswordIntro": "Daveti kabul etmek için davetin gönderildiği hesapla giriş yapın.",
  "acceptInvite.usePassword": "Şifreniz var mı? Şifreyle giriş yapın",
  "acceptInvite.useLink": "E-posta ile giriş bağlantısı al",
  "acceptInvite.checkInbox": "Gelen kutunuzu kontrol edin",
  "acceptInvite.checkInboxBody": "{email} adresine bir giriş bağlantısı gönderdik. E-postadaki bağlantıya bu tarayıcıda tıklayın; bu sayfaya dönüp daveti kabul edebilirsiniz.",
  "acceptInvite.useOtherEmail": "Başka bir adres kullan",
  "acceptInvite.demoNote": "Demo modunda e-posta gönderilmez. Giriş ekranındaki örnek hesaplardan biriyle (şifre: demo) giriş yapabilirsiniz.",
  "acceptInvite.signedInAs": "{email} olarak oturum açtınız.",
  "acceptInvite.displayName": "Adınız",
  "acceptInvite.displayNameHint": "Diğer kullanıcılar sizi bu adla görür.",
  "acceptInvite.accept": "Daveti kabul et",
  "acceptInvite.wrongEmail": "Bu davet başka bir e-posta adresine gönderilmiş. Şu an {email} olarak oturum açtınız; davetin gönderildiği adresle giriş yapın.",
  "acceptInvite.switchAccount": "Farklı hesapla giriş yap",
  "acceptInvite.alreadyMember": "Bu firmaya zaten erişiminiz var.",
  "acceptInvite.toConsole": "Konsola git",

  "map.title": "Canlı harita",
  "map.subtitle": "{tenant} · araçların anlık durumu",
  "map.listLabel": "Araçlar",
  "map.search": "Filo no veya model ara",
  "map.filterLabel": "Duruma göre süz",
  "map.filter.all": "Tümü",
  "map.state.working": "Çalışıyor",
  "map.state.idle": "Rölanti",
  "map.state.off": "Kontak kapalı",
  "map.state.offline": "Çevrim dışı",
  "map.state.alarm": "Alarm",
  "map.noMatch": "Bu süzgece uyan araç yok.",
  "map.empty": "Takip edilen araç yok",
  "map.emptyBody": "Bir aracın haritada görünmesi için ona telematik ünite bağlayın (Cihazlar ekranı).",
  "map.noData": "Henüz veri gelmedi",
  "map.noPosition": "Konum yok",
  "map.stale": "Son bilinen konum",
  "map.feed.connecting": "Bağlanıyor…",
  "map.feed.live": "Canlı",
  "map.feed.reconnecting": "Bağlantı yeniden kuruluyor…",
  "map.loadError": "Canlı veriler yüklenemedi. Bir dakika içinde yeniden denenecek.",
  "map.mapError": "Harita altlığı yüklenemedi; araç listesi çalışmaya devam ediyor.",
  "map.fitAll": "Tümünü göster",
  "map.sitePin": "Saha: {name}",
  "map.vehiclePin": "{fleetNo}, {state}",
  "map.mapLabel": "Araç haritası",
  "map.detail.close": "Kapat",
  "map.detail.openVehicle": "Araç kaydını aç",
  "map.detail.ignition": "Kontak",
  "map.detail.seat": "Koltuk",
  "map.detail.belt": "Emniyet kemeri",
  "map.detail.speed": "Hız",
  "map.detail.operator": "Operatör kartı",
  "map.detail.lastData": "Son veri",
  "map.detail.positionAt": "Konum zamanı",
  "map.detail.lastEvent": "Son olay",
  "map.detail.link": "Bağlantı",
  "map.detail.supply": "Besleme gerilimi",
  "map.detail.device": "Cihaz",
  "map.value.on": "Açık",
  "map.value.off": "Kapalı",
  "map.value.occupied": "Dolu",
  "map.value.empty": "Boş",
  "map.value.fastened": "Takılı",
  "map.value.unfastened": "Takılı değil",
  "map.value.noCard": "Kart okutulmadı",
  "map.value.kmh": "{value} km/sa",
  "map.value.volts": "{value} V",
  "map.value.accuracy": "±{value} m",
  "map.event.impact": "Darbe",
  "map.event.tamper": "Müdahale",
  "map.event.seat_violation": "Koltuk ihlali",
  "map.event.belt_violation": "Kemer ihlali",
  "map.event.power_loss": "Güç kesildi",
  "map.event.power_restore": "Güç geri geldi",
  "map.event.card_ok": "Kartla çalıştırma",
  "map.event.card_denied": "Kart reddedildi",
  "map.event.logout": "Oturum kapandı",
  // Sprint 7a: module events
  "map.event.lift": "Kaldırma",
  "map.event.overload": "Aşırı yük",
  "map.event.charge_start": "Şarj başladı",
  "map.event.charge_end": "Şarj bitti",
  "map.event.deep_discharge": "Akü derin deşarj",
  "map.event.bat_overtemp": "Akü aşırı sıcaklık",
  "map.privacyNote": "Operatör kartı kişisel veridir; yalnızca son dört hanesi gösterilir.",
  "map.event.other": "Diğer olay",
  "map.value.rssi": "{value} dBm",
  "map.value.link.gsm": "GSM (2G/3G)",
  "map.value.link.lte": "GSM (4G/LTE)",
  "map.value.link.wifi": "Wi-Fi",
  "inventory.newClaimCode": "Etiket kodunu yenile",
  "newClaim.title": "{device} için yeni etiket kodu üretilsin mi?",
  "newClaim.body": "Etiket kaybolduysa kullanın. Yeni bir etiket kodu üretilir, eskisi geçersiz olur. Cihazın gizli anahtarı da iptal edilir; ardından anahtarı yenileyip cihaza yükleyin.",
  "newClaim.submit": "Yeni kod üret",
  "newClaim.resultTitle": "{device} için yeni etiket kodu",

  "error.card_in_use": "Bu kart numarası başka bir operatörde aktif. Önce o kartı kayıp ya da iptal olarak işaretleyin.",
  "error.invalid_card": "Kart numarası geçersiz. 8–20 haneli onaltılık (0–9, A–F) bir numara girin.",
  "error.invalid_permission": "Yetki için ya bir saha ya da tek bir araç seçin.",
  "error.invalid_left_on": "Son çalışma günü bir aydan daha eski olamaz. Tarihi kontrol edin; yanlış bir tarih kişisel verilerin erken silinmesine yol açar.",
  "error.operator_left": "Bu operatörün kişisel verileri silinmiş (KVKK). Kayıt artık değiştirilemez.",
  "error.invalid_contact": "Bu kişi sahayı göremiyor. Gece sorumlusu, firmanın bu sahayı görebilen bir kullanıcısı olmalı.",
  "error.invalid_alert_settings": "Mesai ayarı geçersiz. En az bir çalışma günü seçin; başlangıç saati bitiş saatinden önce olmalı.",
  "error.already_acknowledged": "Bu alarm zaten onaylanmış.",
  "error.note_too_long": "Not en fazla 500 karakter olabilir.",
  "map.value.unknownCard": "tanımsız kart",
  "opStatus.active": "Aktif",
  "opStatus.expiring": "Belgesi bitiyor",
  "opStatus.suspended": "Askıda",
  "opStatus.inactive": "Pasif",
  "opStatus.left": "Ayrıldı",
  "operators.title": "Operatörler",
  "operators.subtitle": "{count} operatör",
  "operators.add": "Operatör ekle",
  "operators.filtersLabel": "Operatör filtreleri",
  "operators.search": "Ad veya sicil no ile ara",
  "operators.filterStatus": "Durum",
  "operators.allCurrent": "Ayrılanlar hariç tümü",
  "operators.empty": "Henüz operatör yok",
  "operators.emptyManager": "Operatör ekleyin, kartını tanımlayın ve hangi araçları kullanabileceğini belirleyin.",
  "operators.emptyViewer": "Operatörleri İSG sorumlusu veya filo yöneticisi ekler.",
  "operators.noMatch": "Filtreye uyan operatör yok",
  "operators.readOnly": "Operatörleri görüntüleyebilirsiniz. Kart, belge ve yetki işlemleri İSG sorumlusu ve üzeri rollere açıktır.",
  "operators.back": "Operatörlere dön",
  "operator.fullName": "Ad soyad",
  "operator.employeeNo": "Sicil no",
  "operator.site": "Bağlı olduğu saha",
  "operator.siteAll": "Tüm firma",
  "operator.siteHint": "Operatörü kimlerin görebileceğini belirler. Hangi araçları kullanabileceği yetkilerden gelir.",
  "operator.status": "Durum",
  "operator.cards": "Kartlar",
  "operator.documents": "Belgeler",
  "operator.permissions": "Yetkiler",
  "operator.nextExpiry": "En yakın belge bitişi",
  "operator.identity": "Bilgiler",
  "operator.leftOn": "Son çalışma günü",
  "operator.leftOnHint": "Operatör bu tarihin sonuna kadar araç kullanabilir. Kişisel verileri 6 ay sonra otomatik silinir.",
  "operator.authorizedVehicles": "Bugün kullanabildiği araçlar",
  "operator.noVehicles": "Şu an kullanabildiği araç yok",
  "operator.addTitle": "Operatör ekle",
  "operator.editTitle": "Operatörü düzenle",
  "operator.kvkkNote": "Ad ve sicil no kişisel veridir (KVKK). İşten ayrılan operatörün verileri 6 ay sonra otomatik silinir.",
  "operator.activeLabel": "Aktif (pasif operatör hiçbir araçta kart okutamaz)",
  "operator.leave": "İşten ayrıldı",
  "operator.leaveTitle": "{name} işten ayrıldı olarak işaretlensin mi?",
  "operator.leaveDescription": "Son çalışma gününden sonra kartları hiçbir araçta çalışmaz.",
  "operator.leaveSubmit": "Ayrıldı olarak işaretle",
  "operator.suspendedNote": "Zorunlu bir belgenin süresi doldu. Operatör belge yenilenene kadar hiçbir araçta kart okutamaz.",
  "operator.leftNote": "Son çalışma günü: {day}. Kişisel veriler bu tarihten 6 ay sonra otomatik silinecek.",
  "operator.anonymizedNote": "Bu operatörün kişisel verileri KVKK gereği silindi. Kayıt yalnızca geçmiş raporlar için tutuluyor.",
  "operator.notFound": "Operatör bulunamadı",
  "card.uid": "Kart numarası",
  "card.tech": "Kart tipi",
  "card.status": "Durum",
  "card.operator": "Operatör",
  "card.createdAt": "Eklendi",
  "card.add": "Kart ekle",
  "card.addTitle": "{name} için kart ekle",
  "card.addDescription": "Kart numarasını okuyucunun gösterdiği şekilde girin; boşluk ve iki nokta işaretleri kendiliğinden temizlenir.",
  "card.uidHint": "8–20 haneli onaltılık numara, örneğin 04A1B2C3",
  "card.uidFormat": "8–20 haneli onaltılık (0–9, A–F) bir numara girin.",
  "card.uidNormalized": "Kaydedilecek numara: {uid}",
  "card.none": "Tanımlı kart yok",
  "card.markLost": "Kayıp",
  "card.revoke": "İptal et",
  "card.lostTitle": "Kart kayıp olarak işaretlensin mi?",
  "card.revokeTitle": "Kart iptal edilsin mi?",
  "card.statusBody": "{name} adına kayıtlı {uid} numaralı kart birkaç saniye içinde tüm araçlarda geçersiz olur. Bu işlem geri alınamaz; kart bulunursa yeniden eklenebilir.",
  "cardStatus.active": "Aktif",
  "cardStatus.lost": "Kayıp",
  "cardStatus.revoked": "İptal",
  "cardTech.mifare": "MIFARE (13,56 MHz)",
  "cardTech.hid": "HID",
  "cardTech.em125": "125 kHz (EM)",
  "cards.title": "Kartlar",
  "cards.subtitle": "{count} aktif kart",
  "cards.filtersLabel": "Kart filtreleri",
  "cards.search": "Kart numarası ile ara",
  "cards.showInactive": "Kayıp ve iptal kartları da göster",
  "cards.empty": "Henüz kart yok",
  "cards.emptyHint": "Kartlar operatör sayfasından eklenir.",
  "cards.noMatch": "Aramaya uyan kart yok",
  "cards.note": "Bir kartı kayıp ya da iptal olarak işaretlediğinizde araçlara birkaç saniye içinde iletilir. Çevrim dışı araç, bağlandığı ilk anda güncel listeyi alır.",
  "doc.kind": "Belge",
  "doc.label": "Açıklama",
  "doc.validUntil": "Geçerlilik bitişi",
  "doc.required": "Zorunlu",
  "doc.requiredLabel": "Zorunlu belge",
  "doc.requiredHint": "Zorunlu bir belgenin süresi dolarsa operatör otomatik olarak askıya alınır. Konsol 30, 15 ve 7 gün kala uyarır.",
  "doc.add": "Belge ekle",
  "doc.addTitle": "Belge ekle",
  "doc.editTitle": "Belgeyi düzenle",
  "doc.none": "Kayıtlı belge yok",
  "doc.expired": "Süresi doldu",
  "doc.withinDays": "{days} gün içinde bitiyor",
  "doc.delete": "Belgeyi sil",
  "doc.deleteTitle": "Belge silinsin mi?",
  "doc.deleteBody": "“{kind}” kaydı silinecek. Zorunlu bir belgeyse operatörün araç yetkisi bu belgeye bağlı olmaktan çıkar.",
  "docKind.operator_certificate": "Operatör belgesi",
  "docKind.driving_licence": "Sürücü belgesi",
  "docKind.training": "Eğitim sertifikası",
  "docKind.other": "Diğer",
  "perm.operator": "Operatör",
  "perm.scope": "Kapsam",
  "perm.scopeSite": "{site} (tüm araçlar)",
  "perm.scopeSiteType": "{site} · yalnızca {type}",
  "perm.scopeVehicle": "Yalnızca {vehicle}",
  "perm.scopeSiteOption": "Saha (alt alanlar dahil; sonradan eklenen araçlar da kapsanır)",
  "perm.scopeVehicleOption": "Tek bir araç",
  "perm.site": "Saha",
  "perm.siteHint": "Seçilen sahanın tüm alt alanları dahildir.",
  "perm.vehicleType": "Araç tipi",
  "perm.allTypes": "Tüm tipler",
  "perm.vehicle": "Araç",
  "perm.validUntil": "Bitiş tarihi",
  "perm.validUntilHint": "Boş bırakırsanız süresiz olur. Tarih, araç çevrim dışı olsa bile cihazın kendisi tarafından uygulanır.",
  "perm.openEnded": "Süresiz",
  "perm.expired": "Süresi doldu",
  "perm.add": "Yetki ver",
  "perm.addTitle": "Yetki ver",
  "perm.addTitleFor": "{name} için yetki ver",
  "perm.addDescription": "Operatör, kartı aktif ve zorunlu belgeleri geçerli olduğu sürece bu araçları çalıştırabilir.",
  "perm.none": "Henüz yetki verilmedi",
  "perm.remove": "Yetkiyi kaldır",
  "perm.removeTitle": "Yetki kaldırılsın mı?",
  "perm.removeBody": "{name} için “{scope}” yetkisi kaldırılacak. Araçlar birkaç saniye içinde güncellenir.",
  "permissions.title": "Yetkiler",
  "permissions.subtitle": "Hangi operatörün hangi araçları kullanabileceği",
  "permissions.showExpired": "Süresi dolanları da göster",
  "permissions.empty": "Henüz yetki yok",
  "permissions.emptyHint": "Bir operatöre saha, araç tipi veya tek bir araç için yetki verin.",
  "permissions.note": "Değişiklikler birkaç saniye içinde araçlara iletilir. Çevrim dışı araçlar bağlandıkları ilk anda güncel listeyi alır.",
  "vehicleOps.title": "Bu aracı kullanabilecek operatörler",
  "vehicleOps.until": "Yetki bitişi",
  "vehicleOps.none": "Bugün bu aracı kullanabilecek operatör yok.",
  "vehicleOps.note": "Liste yetkilerden, aktif kartlardan ve belge sürelerinden hesaplanır; cihaza aynısı gönderilir.",
  "authlist.column": "Kart listesi",
  "authlist.synced": "Güncel",
  "authlist.pending": "Gönderiliyor",
  "authlist.error": "Hata",
  "authlist.none": "Gönderilmedi",
  "authlist.syncedAt": "Cihaz listeyi onayladı ({when})",
  "authlist.pendingHint": "Güncel liste cihazın onayını bekliyor. Çevrim dışı cihaz bağlandığında alır.",
  "authlist.errorHint": "Liste iletilemedi: {error}. Her dakika yeniden denenir.",
  "authlist.noneHint": "Bu cihaza henüz liste gönderilmedi.",
  "authlist.noReader": "Kart okuyucu yok",
  "authlist.noReaderHint": "Bu cihazda kart okuyucu yok. Bu yüzden cihaza kart listesi gönderilmez, kartsız çalıştırma ya da yetkisiz kart alarmı da oluşmaz.",
  "authlist.syncNow": "Listeleri şimdi gönder",
  "authlist.syncHint": "Değişiklikler zaten dakikada bir gönderilir; beklemek istemezseniz kullanın.",
  "authlist.syncDone": "Listeler gönderildi.",
  "authlist.syncFailed": "Listeler şu an gönderilemedi; bir dakika içinde otomatik denenir.",

  /* ---- Sprint 6a: alarms (ADR 0011) ---- */
  "alarm.type.impact": "Darbe",
  "alarm.type.unauthorized_start": "Kartsız çalıştırma",
  "alarm.type.card_denied": "Yetkisiz kart denemesi",
  "alarm.type.seat_violation": "Koltuk ihlali",
  "alarm.type.belt_violation": "Kemer ihlali",
  "alarm.type.tamper": "Müdahale",
  "alarm.type.power_loss": "Güç kesildi",
  "alarm.type.geofence_enter": "Yasak bölgeye giriş",
  "alarm.type.geofence_exit": "Çalışma alanından çıkış",
  "alarm.type.geofence_dwell": "Bölgede süre aşımı",
  // Sprint 7a: module alarms
  "alarm.type.overload": "Aşırı yük",
  "alarm.type.deep_discharge": "Akü derin deşarj",
  "alarm.type.bat_overtemp": "Akü aşırı sıcaklık",
  "alarm.type.other": "Diğer olay",
  "alarm.typeWithSeverity": "{type} · Seviye {level}",
  "alarm.status.open": "Açık",
  "alarm.status.acknowledged": "Onaylandı",
  "alarm.badge.offHours": "Mesai dışı",
  "alarm.badge.delayed": "Gecikmeli",
  "alarm.badge.offHoursHint": "Olay sahanın mesai saatleri dışında oldu.",
  "alarm.badge.delayedHint": "Cihaz bu olayı bağlantısı geri gelince geç gönderdi.",
  "alarm.badge.timeUnknown": "Zamanı belirsiz",
  "alarm.badge.timeUnknownHint": "Cihaz saati doğrulanamadı; gösterilen zaman olayın sisteme ulaştığı zamandır.",
  "alarm.badge.repeat": "×{count} tekrar, son: {time}",
  "alarm.badge.repeatNoTime": "×{count} tekrar",
  "alarm.badge.repeatHint": "Aynı olay bu araçta 30 dakika içinde yeniden oldu; yeni alarm ve bildirim oluşturulmadı.",
  "alarm.timeUnknown": "Olay zamanı belirsiz (cihaz saati doğrulanamadı)",
  "alarm.noBlock": "Araç bloke edilmez; darbe yalnızca bildirimdir.",

  "alarms.title": "Alarmlar",
  "alarms.subtitle": "Darbe ve güvenlik olayları. Saatler Türkiye saatiyle gösterilir.",
  "alarms.filtersLabel": "Alarm filtreleri",
  "alarms.filter.status": "Durum",
  "alarms.filter.open": "Açık",
  "alarms.filter.acknowledged": "Onaylanan",
  "alarms.filter.all": "Tümü",
  "alarms.filter.type": "Tür",
  "alarms.filter.allTypes": "Tüm türler",
  "alarms.filter.site": "Saha",
  "alarms.filter.allSites": "Tüm sahalar",
  "alarms.filter.from": "Başlangıç tarihi",
  "alarms.filter.to": "Bitiş tarihi",
  "alarms.filter.clear": "Filtreleri temizle",
  "alarms.filter.dateError": "Bitiş tarihi başlangıçtan önce olamaz.",
  "alarms.shown": "Gösterilen: {count}",
  "alarms.limitNote": "En yeni {limit} alarm gösteriliyor. Daha eskilerini görmek için tarih aralığını daraltın.",
  "alarms.col.time": "Zaman",
  "alarms.col.type": "Tür",
  "alarms.col.vehicle": "Araç",
  "alarms.col.site": "Saha",
  "alarms.col.operator": "Operatör",
  "alarms.col.status": "Durum",
  "alarms.emptyOpen": "Açık alarm yok.",
  "alarms.empty": "Bu filtrelere uyan alarm yok.",
  "alarms.loadError": "Alarmlar yüklenemedi.",
  "alarms.rowLink": "{type} alarmının ayrıntıları, {time}",

  "alarmDetail.back": "Alarmlara dön",
  "alarmDetail.heading": "{type} · {vehicle}",
  "alarmDetail.notFound": "Alarm bulunamadı",
  "alarmDetail.notFoundHint": "Alarm silinmiş olabilir ya da bu sahayı görme yetkiniz olmayabilir.",
  "alarmDetail.facts": "Olay bilgileri",
  "alarmDetail.occurredAt": "Olay zamanı",
  "alarmDetail.receivedAt": "Sisteme ulaştığı zaman",
  "alarmDetail.type": "Tür",
  "alarmDetail.vehicle": "Araç",
  "alarmDetail.site": "Saha",
  "alarmDetail.device": "Cihaz",
  "alarmDetail.operator": "Operatör",
  "alarmDetail.noOperator": "Kart okutulmamış",
  "alarmDetail.workTime": "Mesai",
  "alarmDetail.inHours": "Mesai içinde",
  "alarmDetail.offHours": "Mesai dışında",
  "alarmDetail.delayedNote": "Gecikmeli: olay {time} tarihinde oldu, sisteme {received} tarihinde ulaştı.",
  "alarmDetail.timeUnknownNote": "Olay zamanı belirsiz (cihaz saati doğrulanamadı). Alarm, olayın sisteme ulaştığı zamanla ve aracın şu anki sahasıyla kaydedildi.",
  "alarmDetail.repeats": "Tekrar",
  "alarmDetail.notifyError": "Bu alarm için otomatik bildirim gönderilemedi. İlgili kişileri ayrıca haberdar edin.",
  "alarmDetail.noRecipients": "Bu alarm kimseye bildirilmedi: sahada bildirim alacak kullanıcı yok. Firmaya İSG sorumlusu, filo yöneticisi veya firma yöneticisi ekleyin.",
  "alarmDetail.status": "Durum",
  "alarmDetail.timeZoneNote": "Saatler Türkiye saatidir.",

  "alarmNotify.title": "Kimlere bildirildi",
  "alarmNotify.none": "Görebileceğiniz bir bildirim kaydı yok.",
  "alarmNotify.ownOnly": "Yalnızca size gönderilen bildirimler görünüyor. Sahadaki tüm bildirimleri İSG sorumlusu ve üzeri roller görür.",
  "alarmNotify.recipient": "Alıcı",
  "alarmNotify.channel": "Kanal",
  "alarmNotify.kind": "Bildirim",
  "alarmNotify.status": "Durum",
  "alarmNotify.sentAt": "Gönderim",
  "alarmNotify.you": "{name} (siz)",
  "alarmNotify.unknownUser": "Ekip üyesi",
  "alarmNotify.dueAt": "Planlanan: {time}",
  "alarmChannel.email": "E-posta",
  "alarmChannel.sms": "SMS",
  "alarmChannel.push": "Anlık bildirim",

  /* Sprint 7b (ADR 0019): PWA and web push */
  "nav.profile": "Profilim",
  "profile.title": "Profilim",
  "profile.subtitle": "Hesap bilgileriniz, şifreniz ve bildirim alan cihazlarınız",
  "profile.account": "Hesap",
  "profile.name": "Ad",
  "profile.email": "E-posta",
  "password.title": "Şifre",
  "password.intro": "Konsola e-posta ve şifreyle girmek için şifre belirleyin. Şimdiye kadar yalnızca e-posta bağlantısıyla girdiyseniz de buradan şifre oluşturabilirsiniz.",
  "password.new": "Yeni şifre",
  "password.repeat": "Yeni şifre (tekrar)",
  "password.show": "Şifreyi göster",
  "password.rules": "En az {min}, en fazla {max} karakter; e-posta adresinizle aynı olamaz. Uzun bir cümle veya harf, rakam ve işaret karışımı en güvenlisidir.",
  "password.strength.weak": "Güç: zayıf",
  "password.strength.fair": "Güç: orta",
  "password.strength.strong": "Güç: güçlü",
  "password.submit": "Şifreyi kaydet",
  "password.updated": "Şifreniz güncellendi.",
  "password.err.required": "Yeni şifreyi girin.",
  "password.err.tooShort": "Şifre en az {min} karakter olmalı.",
  "password.err.tooLong": "Şifre en fazla {max} karakter olabilir (Türkçe harfler iki karakter sayılır).",
  "password.err.sameAsEmail": "Şifre e-posta adresinizle aynı olamaz.",
  "password.err.repeatRequired": "Şifreyi tekrar girin.",
  "password.err.mismatch": "İki şifre birbirini tutmuyor.",
  "push.title": "Bildirimler",
  "push.intro": "Size e-postayla gelen anlık alarm bildirimleri, bildirimleri açtığınız cihazlara da gelir. Sabah özeti ve belge hatırlatmaları yalnızca e-postayla gelir. Kilit ekranında görüneceği için bildirimde operatör adı yer almaz.",
  "push.disabledAdmin": "Anlık bildirim sunucuda henüz yapılandırılmadı (VAPID anahtarları eksik). GitHub Actions'ta “VAPID keys” iş akışını çalıştırın (docs/ops/cloud-setup.md, bölüm 4b). E-posta bildirimleri çalışmaya devam ediyor.",
  "push.disabledUser": "Anlık bildirim şu anda kullanılamıyor. Alarm bildirimleri e-postayla gelmeye devam ediyor.",
  "push.configError": "Bildirim ayarları yüklenemedi.",
  "push.env.ios_install": "iPhone veya iPad'de bildirim almak için FTS'yi önce ana ekrana ekleyin: Safari'de Paylaş → Ana Ekrana Ekle. Sonra uygulamayı ana ekrandan açıp bu sayfaya dönün.",
  "push.env.denied": "Bu tarayıcıda FTS için bildirim izni engellenmiş. Tarayıcının site ayarlarından bildirimlere izin verip sayfayı yenileyin.",
  "push.env.unsupported": "Bu tarayıcı anlık bildirimleri desteklemiyor. Chrome, Edge, Firefox veya Safari'nin güncel sürümünü kullanın.",
  "push.thisDevice": "Bu cihaz",
  "push.thisDeviceOn": "Bu cihazda bildirimler açık.",
  "push.thisDeviceOff": "Bu cihazda bildirimler kapalı.",
  "push.enable": "Bu cihazda bildirimleri aç",
  "push.disable": "Bu cihazda kapat",
  "push.enabled": "Bu cihazda bildirimler açıldı.",
  "push.disabled": "Bu cihazda bildirimler kapatıldı.",
  "push.permissionNote": "Tarayıcı izin isteyecek.",
  "push.notRemembered": "Bu cihazda oturum hatırlanmıyor; ortak cihazlarda bildirim açılamaz. Kendi cihazınızda bildirim almak için çıkış yapıp \"Beni hatırla\" işaretliyken yeniden giriş yapın.",
  "push.stale": "Bildirimler yenilenmeli: sunucunun bildirim anahtarı değişti, bu cihaz şu anda bildirim almıyor.",
  "push.renew": "Bildirimleri yenile",
  "push.devices": "Bildirim alan cihazlarım",
  "push.noDevices": "Henüz bildirim açılmış bir cihazınız yok.",
  "push.added": "Eklendi: {date}",
  "push.lastOk": "Son başarılı gönderim: {date}",
  "push.failures": "{n} başarısız deneme",
  "push.remove": "Kaldır",
  "push.removeTitle": "Cihaz kaldırılsın mı?",
  "push.removeText": "{name} artık bildirim almayacak.",
  "push.test": "Test bildirimi gönder",
  "push.testResult": "Test bildirimi gönderildi: {sent} cihaz. Ulaşmayan: {failed}. Kaldırılan: {removed}.",
  "push.err.denied": "Bildirim izni verilmedi.",
  "push.err.noSw": "Bildirim servisi bu sayfada hazır değil. Sayfayı yenileyip tekrar deneyin.",
  "push.err.subscribeFailed": "Bu cihaz bildirim servisine kaydedilemedi. Tekrar deneyin.",
  "error.network": "Bağlantı yok. İnternet bağlantınızı kontrol edip tekrar deneyin.",
  "error.weak_password": "Bu şifre çok zayıf veya kolay tahmin edilebilir. Daha uzun ya da harf, rakam ve işaret karışık bir şifre seçin.",
  "error.same_password": "Yeni şifre mevcut şifrenizle aynı. Farklı bir şifre seçin.",
  "error.reauthentication_needed": "Güvenlik için çıkış yapıp e-posta bağlantısıyla tekrar girin, sonra şifrenizi değiştirin.",
  "error.not_in_demo": "Demo modunda şifre değiştirilemez; demo hesapları sabit bir örnek şifre kullanır.",
  "error.push_disabled": "Anlık bildirim sunucuda yapılandırılmadı.",
  "error.invalid_push_subscription": "Bu cihazın bildirim kaydı geçersiz. Tekrar deneyin.",
  "error.push_device_limit": "En fazla 10 cihazda bildirim açılabilir. Önce kullanmadığınız bir cihazı kaldırın.",
  "pwa.offline": "Bağlantı yok",
  "pwa.updateReady": "Yeni sürüm var.",
  "pwa.reload": "Yenile",
  "pwa.iosHint": "Ana ekrana eklemek için Safari'de Paylaş → Ana Ekrana Ekle'ye dokunun.",
  "lazy.loadError": "Bu bölüm yüklenemedi. Sayfayı yenileyin.",
  "lazy.reload": "Sayfayı yenile",
  "pwa.dismiss": "Kapat",
  "cf.offline": "Bağlantı yok. İnternet bağlantınızı kontrol edip tekrar deneyin.",
  "alarmKind.immediate": "Anlık",
  "alarmKind.digest_item": "Sabah özeti",
  "alarmKind.document_reminder": "Belge hatırlatması",
  "alarmNStatus.pending": "Sırada",
  "alarmNStatus.sending": "Gönderiliyor",
  "alarmNStatus.sent": "Gönderildi",
  "alarmNStatus.failed": "Gönderilemedi",
  "alarmNStatus.skipped": "Gönderilmedi",

  "alarmAck.title": "Onay",
  "alarmAck.button": "Alarmı onayla",
  "alarmAck.noteLabel": "Not",
  "alarmAck.noteHint": "Ne yapıldığını kısaca yazın (en fazla 500 karakter). Onay geri alınamaz.",
  "alarmAck.tooLong": "Not en fazla 500 karakter olabilir.",
  "alarmAck.done": "Alarm onaylandı.",
  "alarmAck.by": "Onaylayan",
  "alarmAck.at": "Onay zamanı",
  "alarmAck.note": "Not",
  "alarmAck.noNote": "Not yazılmadı",
  "alarmAck.waiting": "Bu alarm henüz onaylanmadı.",
  "alarmAck.needsRole": "Alarmları İSG sorumlusu ve üzeri roller onaylar.",

  "map.detail.openAlarm": "Alarmı aç",

  "day.short.1": "Pzt",
  "day.short.2": "Sal",
  "day.short.3": "Çar",
  "day.short.4": "Per",
  "day.short.5": "Cum",
  "day.short.6": "Cmt",
  "day.short.7": "Paz",
  "day.long.1": "Pazartesi",
  "day.long.2": "Salı",
  "day.long.3": "Çarşamba",
  "day.long.4": "Perşembe",
  "day.long.5": "Cuma",
  "day.long.6": "Cumartesi",
  "day.long.7": "Pazar",

  "siteAlerts.title": "Bildirim ayarları",
  "siteAlerts.loadError": "Bildirim ayarları yüklenemedi.",
  "siteAlerts.readOnly": "Bu ayarları filo yöneticisi ve firma yöneticisi değiştirir.",
  "siteAlerts.inherited": "Üst sahadan devralındı: {site}",
  "siteAlerts.own": "Bu sahaya özel",
  "siteAlerts.hours.title": "Mesai saatleri",
  "siteAlerts.hours.summary": "{days} · {start}–{end}",
  "siteAlerts.hours.summaryAllDay": "{days} · tüm gün",
  "siteAlerts.hours.allDay": "Tüm gün",
  "siteAlerts.hours.allDayHint": "00:00–24:00. Bütün günler de seçiliyse alarmlar hiçbir zaman mesai dışı sayılmaz.",
  "siteAlerts.hours.default": "Varsayılan ayar (Pzt–Cum 08:00–18:00)",
  "siteAlerts.hours.tz": "Saat dilimi: Türkiye (İstanbul). Resmî tatiller şimdilik hesaba katılmaz.",
  "siteAlerts.hours.edit": "Mesai saatlerini düzenle",
  "siteAlerts.hours.override": "Bu saha için ayrı saat belirle",
  "siteAlerts.hours.resetParent": "Üst sahanın saatlerine dön",
  "siteAlerts.hours.resetDefault": "Varsayılan saatlere dön",
  "siteAlerts.hours.resetTitle": "Sahaya özel saatler kaldırılsın mı?",
  "siteAlerts.hours.resetBody": "{site} sahasına özel mesai saatleri silinir. Saha bundan sonra üst sahanın saatlerini, o da yoksa varsayılan saatleri kullanır.",
  "siteAlerts.hours.dialogTitle": "Mesai saatleri · {site}",
  "siteAlerts.hours.days": "Çalışma günleri",
  "siteAlerts.hours.start": "Başlangıç saati",
  "siteAlerts.hours.end": "Bitiş saati",
  "siteAlerts.hours.daysRequired": "En az bir gün seçin.",
  "siteAlerts.hours.endAfterStart": "Bitiş saati başlangıçtan sonra olmalı.",
  "siteAlerts.hours.childNote": "Kendi ayarı olmayan alt sahalar da bu saatleri kullanır.",
  "siteAlerts.night.title": "Gece sorumluları",
  "siteAlerts.night.hint": "Mesai dışında olan darbeler bu kişilere hemen e-postayla gider.",
  "siteAlerts.night.none": "Tanımlı değil: mesai dışı darbe gündüz alıcılarına gider",
  "siteAlerts.night.edit": "Gece sorumlularını düzenle",
  "siteAlerts.night.reset": "Sahaya özel listeyi kaldır",
  "siteAlerts.night.resetTitle": "Sahaya özel gece sorumluları kaldırılsın mı?",
  "siteAlerts.night.resetBody": "{site} sahası bundan sonra üst sahanın gece sorumlularını kullanır. Hiçbir üst sahada tanım yoksa mesai dışı darbeler gündüz alıcılarına gider.",
  "siteAlerts.night.dialogTitle": "Gece sorumluları · {site}",
  "siteAlerts.night.pick": "Bu sahayı görebilen kullanıcılar",
  "siteAlerts.night.pickHint": "Kimseyi seçmezseniz saha, üst sahanın gece sorumlularını kullanır.",
  "siteAlerts.inheritedHidden": "Üst sahadan devralındı",
  "siteAlerts.night.noCandidates": "Seçilebilecek kullanıcı yok.",
  "siteAlerts.preview.title": "Şu an bir olay olsa",
  "siteAlerts.preview.inHours": "Şu an mesai içi ({time}).",
  "siteAlerts.preview.offHours": "Şu an mesai dışı ({time}).",
  "siteAlerts.preview.impactNow": "Darbe olursa hemen e-posta alır: {who}.",
  "siteAlerts.preview.othersNow": "Diğer alarmlar da hemen gündüz alıcılarına gider.",
  "siteAlerts.preview.impactFallback": "Gece sorumlusu tanımlı olmadığı için darbe gündüz alıcılarına gider.",
  "siteAlerts.preview.impactDigest": "Hemen e-posta almayan gündüz alıcıları darbeyi {when} sabah özetinde görür.",
  "siteAlerts.preview.othersDigest": "Diğer alarmlar {when} sabah özetiyle gelir: {who}.",
  "siteAlerts.preview.noDigest": "Çalışma günü seçilmediği için sabah özeti gönderilmez.",
  "siteAlerts.preview.dayGroup": "İSG sorumlusu veya filo yöneticisi rolündeki {count} kişi",
  "siteAlerts.preview.dayGroupOne": "İSG sorumlusu veya filo yöneticisi rolündeki 1 kişi",
  "siteAlerts.preview.adminsFallback": "{count} firma yöneticisi",
  "siteAlerts.preview.adminsFallbackOne": "1 firma yöneticisi",
  "siteAlerts.preview.dayGroupWithAdmins": "İSG sorumlusu, filo yöneticisi veya yönetici rolündeki {count} kişi",
  "siteAlerts.preview.dayGroupWithAdminsOne": "İSG sorumlusu, filo yöneticisi veya yönetici rolündeki 1 kişi",
  "siteAlerts.preview.impactAdminsToo": "Darbe aynı anda {count} firma yöneticisine de gider.",
  "siteAlerts.preview.impactAdminsTooOne": "Darbe aynı anda 1 firma yöneticisine de gider.",
  "siteAlerts.preview.adminsCopy": "Firma yöneticileri her alarmın kopyasını da alır (Kullanıcılar ve roller ekranındaki ayar).",
  "siteAlerts.preview.noRecipients": "Bu sahada bildirim alacak kullanıcı tanımlı değil; darbe kimseye gitmez.",
  "siteAlerts.preview.impactNobody": "Darbe olursa kimseye e-posta gitmez.",
  "siteAlerts.preview.othersNobody": "Diğer alarmlar da kimseye gitmez.",
  "siteAlerts.preview.othersDigestNobody": "Diğer alarmların {when} sabah özeti kimseye gitmez.",
  // ADR 0014: live watch
  "error.device_offline": "Cihaz çevrim dışı; canlı izleme cihaz bağlanınca başlatılabilir.",
  "error.too_many_live_watches": "Aynı anda en fazla 5 araç canlı izlenebilir. Biri bitince tekrar deneyin.",
  "liveWatch.waiting": "Cihaz bekleniyor",
  "liveWatch.waitingLabel": "Canlı izleme komutu gönderildi, cihazın onayı bekleniyor",
  "liveWatch.start": "Canlı izle (10 dk)",
  "liveWatch.starting": "Başlatılıyor…",
  "liveWatch.active": "Canlı izleniyor · {time}",
  "liveWatch.activeLabel": "Canlı izleme açık, kalan süre {time}",
  "liveWatch.tooSoon": "Bu araç için az önce canlı izleme istendi. 30 saniye sonra tekrar deneyin.",
  "liveWatch.hint": "Araç 10 dakika boyunca saniyede bir konum gönderir, sonra normal aralığa döner. Aracın çalışmasına hiçbir etkisi yoktur.",

  "geofence.title": "Bölgeler",
  "geofence.add": "Bölge ekle",
  "geofence.intro": "Yasak bölge, çalışma alanı veya süre sınırı tanımlayın; kural bozulursa alarm oluşur ve bildirim kurallarına göre iletilir.",
  "geofence.empty": "Bu sahada tanımlı bölge yok.",
  "geofence.emptyEditable": "Bu sahada henüz bölge yok. Yaya yolları gibi yasak bölgeleri veya çalışma alanlarını haritada çizerek ekleyebilirsiniz.",
  "geofence.loadError": "Bölgeler yüklenemedi.",
  "geofence.tableCaption": "{site} bölgeleri",
  "geofence.name": "Ad",
  "geofence.nameHint": "Haritada ve alarmlarda bu ad görünür. Örnek: Yaya yolu – ana giriş.",
  "geofence.kind": "Tür",
  "geofence.shape": "Şekil",
  "geofence.vehicleTypes": "Araç tipleri",
  "geofence.status": "Durum",
  "geofence.actions": "İşlemler",
  "geofence.active": "Etkin",
  "geofence.inactive": "Pasif",
  "geofence.editNamed": "{name} bölgesini düzenle",
  "geofence.deleteNamed": "{name} bölgesini sil",
  "geofence.readOnly": "Bölgeleri İSG sorumlusu, filo yöneticisi ve firma yöneticisi düzenler.",
  "geofence.saved": "{name} kaydedildi.",
  "geofence.deleted": "{name} silindi.",
  "geofence.limitReached": "Bir sahada en fazla {max} bölge olabilir.",
  "geofence.kind.forbidden": "Yasak bölge",
  "geofence.kind.work_area": "Çalışma alanı",
  "geofence.kind.dwell": "Süre sınırı",
  "geofence.kindHint.forbidden": "Araç bu bölgeye girerse alarm oluşur. Yaya yolları ve dar geçitler için.",
  "geofence.kindHint.work_area": "Araç bu alanın dışına çıkarsa alarm oluşur.",
  "geofence.kindHint.dwell": "Araç bölgede belirlediğiniz dakikadan uzun kalırsa alarm oluşur.",
  "geofence.rule.forbidden": "Araç girerse alarm",
  "geofence.rule.work_area": "Araç dışına çıkarsa alarm",
  "geofence.rule.dwell": "Araç {duration} süreden uzun kalırsa alarm",
  "geofence.minutes": "{m} dk",
  "geofence.hours": "{h} sa",
  "geofence.hoursMinutes": "{h} sa {m} dk",
  "geofence.shapePolygonSummary": "Çokgen · {count} köşe",
  "geofence.shapeCircleSummary": "Daire · {radius} m",
  "geofence.allVehicleTypes": "Tüm araçlar",
  "geofence.addTitle": "Yeni bölge",
  "geofence.editTitle": "Bölgeyi düzenle",
  "geofence.dialogHint": "Saha: {site}",
  "geofence.dwellMinutes": "Süre sınırı (dakika)",
  "geofence.dwellHint": "{min}–{max} dakika. Araç bölgede {minutes} dakikadan uzun kalırsa alarm oluşur; her girişte bir kez.",
  "geofence.shape.polygon": "Çokgen",
  "geofence.shape.circle": "Daire",
  "geofence.drawPolygonHint": "Köşe eklemek için haritaya tıklayın; köşeleri sürükleyerek taşıyın. Klavyeyle: haritayı ok tuşlarıyla kaydırıp \"Harita ortasına köşe ekle\"ye basın; seçili köşe ok tuşlarıyla 1 m (Shift ile 5 m) kayar, Delete ile silinir.",
  "geofence.drawCircleHint": "Merkezi seçmek için haritaya tıklayın veya merkezi sürükleyin, ardından yarıçapı girin.",
  "geofence.mapError": "Harita yüklenemedi. Bağlantınızı kontrol edip yeniden deneyin.",
  "geofence.mapLabel": "Bölge çizim haritası",
  "geofence.vertexLabel": "Köşe {n}",
  "geofence.centerLabel": "Dairenin merkezi",
  "geofence.vertexCount": "{count} köşe",
  "geofence.addVertexAtCenter": "Harita ortasına köşe ekle",
  "geofence.undoVertex": "Son köşeyi geri al",
  "geofence.clearVertices": "Temizle",
  "geofence.centerSet": "Merkez seçildi",
  "geofence.centerMissing": "Merkez seçilmedi",
  "geofence.centerAtMapCenter": "Merkezi harita ortasına koy",
  "geofence.radius": "Yarıçap (m)",
  "geofence.radiusHint": "{min}–{max} metre.",
  "geofence.vehicleTypesHint": "Hiçbirini seçmezseniz bölge tüm araçlar için geçerlidir.",
  "geofence.activeLabel": "Etkin",
  "geofence.activeHint": "Pasif bölge alarm üretmez; silinmeden saklanır.",
  "geofence.gnssNote": "Bölgeler yalnızca açık alandaki uydu (GNSS) konumuyla değerlendirilir; kapalı alanda alarm oluşmaz. Sınırda titremeyi önlemek için araç sınırı en az 3 m geçip en az 5 sn ve art arda 5 konum boyunca orada kalınca durum değişir; bu yüzden bölgeler en az 10 m genişliğinde olmalıdır. Süre sınırı alarmı, araçtan son 5 dakika içinde bölgeden konum geldiyse oluşur. Alarm yalnızca bildirimdir, araç durdurulmaz.",
  "geofence.deleteTitle": "Bölge silinsin mi?",
  "geofence.deleteBody": "{name} silinecek. Bu bölge için daha önce oluşan alarmlar kalır, ancak bölgenin şekli artık gösterilmez.",
  "geofence.issue.name_required": "Bölgeye bir ad verin.",
  "geofence.issue.name_too_long": "Ad en fazla 80 karakter olabilir.",
  "geofence.issue.invalid_kind": "Bir tür seçin.",
  "geofence.issue.invalid_shape": "Çokgen veya daire seçin.",
  "geofence.issue.invalid_coordinate": "Bölgenin konumu eksik veya geçersiz. Haritada yeniden çizin.",
  "geofence.issue.too_few_vertices": "Çokgen için haritada en az 3 köşe işaretleyin.",
  "geofence.issue.too_many_vertices": "Bir çokgen en fazla 200 köşeli olabilir.",
  "geofence.issue.self_intersecting": "Çokgenin kenarları birbirini kesiyor. Köşeleri taşıyarak düzeltin.",
  "geofence.issue.too_narrow": "Bölge en az 10 m genişliğinde olmalı. GPS sahada 2–5 m sapabildiği için daha dar alanlar (ör. yaya yolları) güvenilir izlenemez; bu tür alanlar için UWB veya kamera tabanlı çözümler önerilir.",
  "geofence.issue.radius_out_of_range": "Yarıçap en fazla 5000 metre olabilir.",
  "geofence.issue.dwell_out_of_range": "Süre 1 ile 1440 dakika arasında tam sayı olmalı.",
  "geofence.issue.dwell_only_for_dwell": "Süre yalnızca süre sınırı bölgelerinde kullanılır.",
  "geofence.issue.invalid_vehicle_type": "Bilinmeyen araç tipi seçildi.",
  "alarmZone.title": "Bölge",
  "alarmZone.zone": "Bölge",
  "alarmZone.deleted": "Bölge silinmiş",
  "alarmZone.unavailable": "Bölge görüntülenemiyor",
  "alarmZone.kind": "Kural",
  "alarmZone.point": "İhlal noktası",
  "alarmZone.noPoint": "Konum yok (alarm, araç bölgede kalırken dakikalık kontrolle oluştu)",

  "alarmZone.mapLabel": "Bölge ve ihlal noktası haritası",
  "alarmZone.pointPin": "İhlal noktası",
  "alarmZone.noBlock": "Araç durdurulmaz; bölge alarmı yalnızca bildirimdir.",
  "map.zones.toggle": "Bölgeleri göster",
  "map.zones.legend": "Bölge türleri",
  "error.invalid_geofence": "Bölge kaydedilemedi: şekil, ad veya süre kurallara uymuyor.",
  "error.too_many_geofences": "Bu sahada bölge sınırına (50) ulaşıldı.",

  /* Sprint 7a: pre-shift checklist (ADR 0016) */
  "error.checklist_token_invalid": "Bu QR kod geçersiz veya yenilenmiş.",
  "error.invalid_checklist": "Kontrol listesi eksik veya hatalı.",
  "error.invalid_photo": "Fotoğraf kabul edilmedi: JPEG, PNG veya WebP ve en fazla 5 MB olmalı.",
  "error.invalid_template": "Şablon kaydedilemedi: ad, madde kodu veya metin kurallara uymuyor.",
  "error.invalid_shift": "Vardiya kaydedilemedi: ad, saatler veya günler geçersiz.",
  "error.too_many_shifts": "Bu sahada vardiya sınırına (10) ulaşıldı.",
  "error.invalid_recipient": "Alıcı eklenemedi: kişi bu sahayı göremiyor, adres geçersiz veya zaten listede.",
  "error.fault_resolved": "Bu arıza zaten giderildi olarak işaretlenmiş.",
  "alarm.type.checklist_critical": "Kontrol listesi: kritik arıza",
  "alarm.type.checklist_missed": "Kontrol listesi doldurulmadı",
  "alarm.type.checklist_notes": "Kontrol listesi: arıza bildirimi",
  "alarmKind.maintenance_report": "Bakım raporu (dış adres)",
  "alarmNotify.external": "Dış adres",
  "alarmChecklist.title": "Kontrol listesi",
  "alarmChecklist.shift": "Vardiya",
  "alarmChecklist.open": "Aracın kontrol listelerini aç",
  "alarmChecklist.missedText": "Araç bu vardiyada kontrol listesi doldurulmadan kullanıldı.",
  "alarmChecklist.noLock": "Araç kilitlenmez; bu yalnızca bildirimdir.",
  "nav.group.checklist": "Kontrol listesi",
  "nav.checklistFaults": "Arızalar",
  "nav.checklistTemplates": "Şablonlar",
  "checklist.category.counterbalance_electric": "Akülü forklift",
  "checklist.category.counterbalance_ic": "Dizel/LPG forklift",
  "checklist.category.reach_truck": "Reach truck",
  "checklist.category.order_picker": "Sipariş toplama aracı",
  "checklist.category.pallet_truck": "Akülü transpalet",
  "checklist.systemName": "{category} (standart)",
  "checklist.result.ok": "Uygun",
  "checklist.result.ok_with_notes": "Uygun, bildirim var",
  "checklist.result.maintenance_required": "Bakım gerekli",
  "checklist.answer.ok": "Uygun",
  "checklist.answer.not_ok": "Uygun değil",
  "checklist.answer.na": "Yok",
  "checklist.critical": "Kritik",
  "checklist.photoRequired": "Fotoğraf",
  "cf.title": "Vardiya öncesi kontrol",
  "cf.invalid": "Bu QR kod geçersiz veya yenilenmiş. Lütfen yöneticinize haber verin.",
  "cf.rateLimited": "Çok fazla deneme yapıldı. Birkaç dakika sonra tekrar deneyin.",
  "cf.loadError": "Form yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
  "cf.shift": "Vardiya: {name}",
  "cf.noShift": "Tanımlı vardiya dışında",
  "cf.alreadySubmitted": "Bu vardiya için kontrol listesi zaten doldurulmuş. Gerekirse yeniden doldurabilirsiniz.",
  "cf.openFaults": "Açık arızalar (önceki kontrollerden)",
  "cf.intro": "Her maddeyi kontrol edin ve işaretleyin. Araçta olmayan donanım için \"Yok\" seçin.",
  "cf.note": "Not",
  "cf.notePlaceholder": "Ne gördüğünüzü kısaca yazın",
  "cf.addPhoto": "Fotoğraf ekle",
  "cf.photoUploading": "Fotoğraf yükleniyor…",
  "cf.photoRemove": "Fotoğrafı kaldır",
  "cf.photoAlt": "{code} maddesinin fotoğrafı {n}",
  "cf.photoCount": "{n}/3 fotoğraf",
  "cf.progress": "{done}/{total} madde",
  "cf.submit": "Gönder",
  "cf.submitting": "Gönderiliyor…",
  "cf.missing": "{n} madde eksik. İşaretli maddeleri tamamlayın.",
  "cf.done": "Teşekkürler, kontrol listesi kaydedildi.",
  "cf.doneDetail": "{fleetNo} · {time}",
  "cf.again": "Yeni kontrol listesi doldur",
  "cf.waitPhotos": "Fotoğraflar yükleniyor; bitince tekrar \"Gönder\"e dokunun.",
  "error.form_changed": "Form güncellendi, yeniden yükleyin.",
  "cf.formChanged": "Form güncellendi, yeniden yükleyin. Değişmeyen maddelerdeki yanıtlarınız korunur.",
  "cf.reload": "Formu yeniden yükle",
  "cf.naNotAllowed": "Bu maddede \"Yok\" seçilemez",
  "cf.issue.na_not_allowed": "Bu madde için \"Yok\" seçilemez; \"Uygun\" veya \"Uygun değil\" seçin.",
  "templateEdit.allowNa": "Kritik olsa da \"Yok\" yanıtına izin ver (koşullu donanım)",
  "checklist.allowNa": "\"Yok\" seçilebilir",
  "cf.language": "Dil",
  "cf.issue.missing_answer": "Bir seçenek işaretleyin.",
  "cf.issue.duplicate_answer": "Bu madde birden fazla yanıtlandı.",
  "cf.issue.unknown_item": "Bu madde artık şablonda yok. Formu yenileyin.",
  "cf.issue.invalid_answer": "Geçersiz yanıt.",
  "cf.issue.note_required": "\"Uygun değil\" için not yazın.",
  "cf.issue.note_too_long": "Not en fazla 500 karakter olabilir.",
  "cf.issue.photo_required": "Bu madde için fotoğraf ekleyin.",
  "cf.issue.too_many_photos": "En fazla 3 fotoğraf eklenebilir.",
  "vehicleDetail.tab.checklist": "Kontrol listesi",
  "vehicleChecklist.maintenance": "Bakım gerekli",
  "vehicleChecklist.maintenanceHint": "Açık kritik arıza var. Araç kilitlenmez; arıza giderilince işaretleyin.",
  "vehicleChecklist.openFaults": "Açık arızalar",
  "vehicleChecklist.noOpenFaults": "Açık arıza yok.",
  "vehicleChecklist.history": "Kontrol listesi geçmişi",
  "vehicleChecklist.empty": "Bu araç için henüz kontrol listesi doldurulmadı.",
  "vehicleChecklist.when": "Zaman",
  "vehicleChecklist.shift": "Vardiya",
  "vehicleChecklist.operator": "Operatör",
  "vehicleChecklist.operatorUnknown": "Belirlenemedi (kart oturumu yok)",
  "vehicleChecklist.result": "Sonuç",
  "vehicleChecklist.template": "Şablon",
  "vehicleChecklist.details": "Ayrıntılar",
  "vehicleChecklist.hideDetails": "Ayrıntıları gizle",
  "vehicleChecklist.impact": "Önceki kontrolden sonra darbe alarmı vardı",
  "vehicleChecklist.loadError": "Kontrol listeleri yüklenemedi.",
  "vehicleChecklist.photos": "Fotoğraflar",
  "checklistQr.title": "QR etiketi",
  "checklistQr.hint": "Etiketi aracın operatörün göreceği bir yerine yapıştırın. QR kod, formu konsola giriş yapmadan açar.",
  "checklistQr.print": "Etiketi yazdır",
  "checklistQr.printAll": "Etiket sayfası yazdır",
  "checklistQr.rotate": "QR kodunu yenile",
  "checklistQr.rotateTitle": "QR kodu yenilensin mi?",
  "checklistQr.rotateText": "Eski etiket hemen çalışmaz hâle gelir. Yeni etiketi yazdırıp eskisinin yerine yapıştırın.",
  "checklistQr.noAccess": "QR kodunu filo yöneticisi ve üzeri görebilir.",
  "checklistQr.labelTitle": "Vardiya öncesi kontrol",
  "checklistQr.labelText": "Vardiya başında bu kodu telefonunuzla okutun ve formu doldurun (yaklaşık 3 dakika).",
  "checklistQr.labelSample": "Örnek etiket metni — sahaya göre uyarlayın.",
  "checklistQr.link": "Form bağlantısı",
  "checklistQr.copy": "Bağlantıyı kopyala",
  "checklistQr.sheetTitle": "QR etiketleri · {site}",
  "checklistQr.close": "Kapat",
  "faults.title": "Arızalar",
  "faults.subtitle": "Kontrol listelerinde \"Uygun değil\" işaretlenen maddeler",
  "faults.filter.open": "Açık",
  "faults.filter.resolved": "Giderildi",
  "faults.filter.all": "Tümü",
  "faults.filterLabel": "Duruma göre süz",
  "faults.vehicle": "Araç",
  "faults.item": "Madde",
  "faults.note": "Not",
  "faults.reported": "Bildirildi",
  "faults.status": "Durum",
  "faults.status.open": "Açık",
  "faults.status.resolved": "Giderildi",
  "faults.resolve": "Giderildi",
  "faults.resolveTitle": "Arıza giderildi mi?",
  "faults.resolveNote": "Yapılan işlem",
  "faults.resolveHint": "Örn. lastik değiştirildi. En fazla 500 karakter.",
  "faults.resolvedBy": "{name} · {time}",
  "faults.empty": "Bu süzgeçle arıza yok.",
  "faults.needsRole": "Arızaları filo yöneticisi ve üzeri kapatır.",
  "faults.photos": "{n} fotoğraf",
  "templates.title": "Kontrol listesi şablonları",
  "templates.subtitle": "Standart şablonu kopyalayıp kendi maddelerinizi ekleyebilir ve araç tiplerine atayabilirsiniz.",
  "templates.system": "Standart",
  "templates.own": "Firma şablonu",
  "templates.items": "{n} madde",
  "templates.copy": "Kopyala",
  "templates.copyName": "{name} (kopya)",
  "templates.view": "Görüntüle",
  "templates.delete": "Sil",
  "templates.deleteTitle": "Şablon silinsin mi?",
  "templates.deleteText": "Atandığı araç tipleri standart şablona döner. Doldurulmuş kontrol listeleri değişmez.",
  "templates.assignTitle": "Araç tiplerine atama",
  "templates.assignHint": "Her araç tipi, burada seçilen şablonla kontrol edilir. Seçim yoksa standart şablon kullanılır.",
  "templates.category": "Araç tipi",
  "templates.template": "Şablon",
  "templates.useSystem": "Standart şablon",
  "templates.viewOnly": "Şablonları saha kısıtı olmayan filo yöneticisi ve firma yöneticisi düzenler.",
  "templates.critical": "{n} kritik",
  "templateEdit.title": "Şablonu düzenle",
  "templateEdit.viewTitle": "Şablon maddeleri",
  "templateEdit.name": "Şablon adı",
  "templateEdit.code": "Kod",
  "templateEdit.textTr": "Madde (Türkçe)",
  "templateEdit.textEn": "Madde (İngilizce)",
  "templateEdit.critical": "Kritik (uygun değilse hemen bildirim)",
  "templateEdit.photo": "Uygun değilse fotoğraf zorunlu",
  "templateEdit.impactFirst": "Darbeden sonra ilk sırada göster",
  "templateEdit.lpgOnly": "Yalnız LPG'li araçlarda",
  "templateEdit.moveUp": "Yukarı taşı",
  "templateEdit.moveDown": "Aşağı taşı",
  "templateEdit.remove": "Maddeyi kaldır",
  "templateEdit.add": "Madde ekle",
  "templateEdit.itemLabel": "Madde {n}",
  "templateEdit.noLock": "Kritik maddeler aracı kilitlemez; yalnızca seçilen kişilere hemen bildirim gider.",
  "templateEdit.issue.name_required": "Şablon adı girin.",
  "templateEdit.issue.name_too_long": "Şablon adı en fazla 80 karakter olabilir.",
  "templateEdit.issue.no_items": "En az bir madde ekleyin.",
  "templateEdit.issue.too_many_items": "Bir şablonda en fazla 60 madde olabilir.",
  "templateEdit.issue.text_required": "Madde metnini (Türkçe) girin.",
  "templateEdit.issue.text_too_long": "Madde metni en fazla 200 karakter olabilir.",
  "templateEdit.issue.invalid_code": "Kod 1–8 karakter: büyük harf, rakam veya tire.",
  "templateEdit.issue.duplicate_code": "Bu kod başka bir maddede kullanılıyor.",
  "siteChecklist.title": "Vardiya öncesi kontrol listesi",
  "siteChecklist.shiftsTitle": "Vardiyalar",
  "siteChecklist.shiftsHint": "Kontrol listesi her vardiya başında zorunludur. Vardiyada kullanılan ama kontrol listesi doldurulmayan araç için 15 dakika sonra alarm oluşur.",
  "siteChecklist.inherited": "Üst sahadan devralındı: {site}",
  "siteChecklist.inheritedHidden": "Üst sahadan devralındı",
  "siteChecklist.noShifts": "Vardiya tanımlı değil: \"kontrol listesi doldurulmadı\" alarmı oluşmaz.",
  "siteChecklist.addShift": "Vardiya ekle",
  "siteChecklist.editShift": "Vardiyayı düzenle",
  "siteChecklist.shiftName": "Vardiya adı",
  "siteChecklist.start": "Başlangıç",
  "siteChecklist.end": "Bitiş",
  "siteChecklist.days": "Günler (başlangıç günü)",
  "siteChecklist.timeZone": "Saat dilimi",
  "siteChecklist.overnight": "ertesi gün {time}",
  "siteChecklist.deleteShift": "Vardiyayı sil",
  "siteChecklist.deleteShiftText": "\"{name}\" vardiyası silinsin mi? Geçmiş kontrol listeleri değişmez.",
  "siteChecklist.recipientsTitle": "Kontrol listesi bildirimleri",
  "siteChecklist.recipientsHint": "Kritik arıza ve doldurulmayan kontrol listesi bu kişilere hemen gider; kritik olmayan arızalar günlük özete girer. Operatöre uyarı gösterilmez, araç kilitlenmez.",
  "siteChecklist.noRecipients": "Alıcı tanımlı değil: bildirimler sahanın İSG sorumlusu ve filo yöneticisine gider.",
  "siteChecklist.addMember": "Konsol kullanıcısı ekle",
  "siteChecklist.addExternal": "Dış e-posta ekle",
  "siteChecklist.member": "Kullanıcı",
  "siteChecklist.email": "E-posta adresi",
  "siteChecklist.label": "Açıklama",
  "siteChecklist.labelHint": "Örn. dış bakım firmasının adı.",
  "siteChecklist.externalHint": "Dış adreslere araç, arızalı maddeler, notlar ve 7 gün geçerli fotoğraf bağlantıları gider; operatör adı gönderilmez (KVKK).",
  "siteChecklist.external": "Dış adres",
  "siteChecklist.remove": "Kaldır",
  "siteChecklist.removeTitle": "Alıcı kaldırılsın mı?",
  "siteChecklist.removeText": "{name} artık bu sahanın kontrol listesi bildirimlerini almaz.",
  "siteChecklist.externalAdminOnly": "Dış e-posta adreslerini yalnızca firma yöneticisi ekler veya siler.",
  "siteChecklist.loadError": "Kontrol listesi ayarları yüklenemedi.",
  "siteChecklist.ownList": "Bu sahanın listesi",
  "siteChecklist.applies": "Şu anda geçerli alıcılar",
} as const satisfies Record<string, string>;

export type MessageKey = keyof typeof tr;
export type Messages = Record<MessageKey, string>;
